/* Certified Sunglasses - Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  // Formats cents the same way Liquid's `money` filter does for the shopper's
  // current currency. theme.liquid renders a sample amount (1234.56) through
  // `money` into window.themeMoneySample, so the symbol, its position and the
  // thousands/decimal separators all come from Shopify itself. Prices used to
  // be built as '$' + toFixed(2), which dropped the thousands separator
  // ("$1575.00" instead of "$1,575.00") after a variant switch.
  function themeFormatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    var sample = window.themeMoneySample || '$1,234.56';
    var m = sample.match(/1(\D?)234(\D)56/);
    var parts = (Math.abs(cents) / 100).toFixed(2).split('.');
    if (!m) return (cents < 0 ? '-' : '') + '$' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
    return (cents < 0 ? '-' : '') + sample.replace(m[0], whole + m[2] + parts[1]);
  }
  window.themeFormatMoney = themeFormatMoney;

  function themeString(key, fallback) {
    return (window.themeStrings && window.themeStrings[key]) || fallback;
  }

  // Single AJAX add-to-cart used by the product page, Buy Now and collection
  // cards. Resolves with the added line item; rejects with Shopify's own
  // message (e.g. "All 1 ... are in your cart.") whenever the add fails, so
  // callers never treat a failed add as a success.
  function themeCartAdd(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || (data && data.status && !data.id)) {
          var msg = data && typeof data.description === 'string' && data.description ? data.description
            : (data && typeof data.message === 'string' && data.message ? data.message : '');
          throw new Error(msg || themeString('cartAddError', 'Could not add to cart. Please try again.'));
        }
        return data;
      });
    });
  }

  // Sezzle pay-in-4 line for product cards built in JS (collection infinite
  // scroll, wishlist) — mirrors snippets/sezzle-message.liquid's 'card' style.
  // window.themeSezzleCards is set from the theme setting in theme.liquid.
  function sezzleCardHtml(cents) {
    cents = parseInt(cents, 10);
    if (!window.themeSezzleCards || !cents) return '';
    return '<p class="sezzle-msg--card sezzle-msg"><span class="sezzle-msg__text">or 4 × <strong data-sezzle-installment>' +
      themeFormatMoney(Math.floor(cents / 4)) + '</strong> with</span><span class="sezzle-msg__logo" aria-label="Sezzle">sezzle</span></p>';
  }

  // ========================
  // DAY / NIGHT (DARK MODE) TOGGLE
  // ========================
  (function () {
    var toggleBtns = document.querySelectorAll('[data-theme-toggle]');
    if (!toggleBtns.length) return;

    function getSavedMode() {
      try { return localStorage.getItem('cs-theme-mode'); } catch (e) { return null; }
    }
    function saveMode(mode) {
      try { localStorage.setItem('cs-theme-mode', mode); } catch (e) {}
    }
    function applyMode(mode) {
      if (mode === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        document.documentElement.removeAttribute('data-theme');
      }
      toggleBtns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
      });
    }

    applyMode(getSavedMode() === 'dark' ? 'dark' : 'light');

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
        var next = isDark ? 'light' : 'dark';
        applyMode(next);
        saveMode(next);
      });
    });
  })();

  // ========================
  // MEGA MENU
  // ========================
  var megaItems = document.querySelectorAll('.mega-nav-item');
  var activeItem = null;
  var closeTimer = null;

  function openMega(item) {
    if (activeItem && activeItem !== item) closeMega(activeItem);
    clearTimeout(closeTimer);
    item.classList.add('is-open');
    item.querySelector('.site-nav__link').setAttribute('aria-expanded', 'true');
    activeItem = item;
    hideEmptyMegaFilters(item);
  }

  // Women / Men menus: on first open, hide every shape / color / lens link that has
  // no products in that collection (so no menu link ever lands on "0 products").
  // Links stay visible if the data can't be loaded, rather than emptying the menu.
  function hideEmptyMegaFilters(item) {
    var panel = item.querySelector('[data-filter-collection]');
    if (!panel || panel.dataset.filtersChecked) return;
    panel.dataset.filtersChecked = 'true';
    loadCollectionFilterData(panel.dataset.filterCollection).then(function(map) {
      if (!map) { delete panel.dataset.filtersChecked; return; }
      var present = { shapes: {}, colors: {}, lens: {} };
      Object.keys(map).forEach(function(handle) {
        var d = map[handle];
        if (d.s) present.shapes[d.s] = true;
        (d.c || '').split('|').forEach(function(c) { if (c) present.colors[c] = true; });
        (d.l || '').split('|').forEach(function(l) { if (l) present.lens[l] = true; });
      });
      panel.querySelectorAll('[data-mega-filter]').forEach(function(link) {
        var set = present[link.dataset.megaFilter];
        if (set) link.hidden = !set[link.dataset.megaValue];
      });
    });
  }

  function closeMega(item) {
    item.classList.remove('is-open');
    item.querySelector('.site-nav__link').setAttribute('aria-expanded', 'false');
    if (activeItem === item) activeItem = null;
  }

  megaItems.forEach(function (item) {
    // Open on mouseenter
    item.addEventListener('mouseenter', function () {
      openMega(item);
    });
    // Delay close on mouseleave so cursor can move into the panel
    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () { closeMega(item); }, 120);
    });
    // Toggle on click (for keyboard / touch)
    item.querySelector('.site-nav__link').addEventListener('click', function (e) {
      if (window.innerWidth >= 900) {
        // On desktop, only prevent navigation if chevron was the click target — allow link through otherwise
        if (item.classList.contains('is-open')) {
          closeMega(item);
        } else {
          e.preventDefault();
          openMega(item);
        }
      }
    });
  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.mega-nav-item')) {
      megaItems.forEach(function (item) { closeMega(item); });
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      megaItems.forEach(function (item) { closeMega(item); });
      closeMobileNav();
      closeSearch();
    }
  });

  // ========================
  // MOBILE ANNOUNCEMENT BAR TEXT ROTATOR
  // ========================
  var announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementBar) {
    var mobileText = announcementBar.querySelector('[data-announcement-mobile-text]');
    if (mobileText) {
      var announcementPhrases = [];
      announcementBar.querySelectorAll('.announcement-bar__item--desktop .announcement-bar__text').forEach(function(item) {
        var text = (item.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        // The coupon message keeps its markup (badge + code chip) on phones too;
        // every other message stays plain text exactly as before.
        var isCoupon = item.parentElement && item.parentElement.classList.contains('announcement-bar__item--center');
        announcementPhrases.push(isCoupon ? { html: item.outerHTML } : text);
      });

      if (announcementPhrases.length > 0) {
        var announcementIndex = 0;
        var announcementTimer = null;

        function updateAnnouncementText() {
          if (window.innerWidth > 640) {
            mobileText.textContent = '';
            return;
          }

          var phrase = announcementPhrases[announcementIndex];
          if (typeof phrase === 'string') {
            mobileText.textContent = phrase;
          } else {
            mobileText.innerHTML = phrase.html;
          }
          announcementIndex = (announcementIndex + 1) % announcementPhrases.length;
        }

        function startAnnouncementRotation() {
          if (window.innerWidth > 640) {
            clearInterval(announcementTimer);
            announcementTimer = null;
            mobileText.textContent = '';
            return;
          }

          if (announcementTimer) return;
          updateAnnouncementText();
          announcementTimer = setInterval(updateAnnouncementText, 5000);
        }

        function stopAnnouncementRotation() {
          clearInterval(announcementTimer);
          announcementTimer = null;
          mobileText.textContent = '';
        }

        window.addEventListener('resize', function() {
          if (window.innerWidth <= 640) {
            startAnnouncementRotation();
          } else {
            stopAnnouncementRotation();
          }
        });

        startAnnouncementRotation();
      }
    }
  }

  // Announcement bar coupon chip: click to copy the code
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-announcement-copy]');
    if (!chip) return;
    var code = chip.getAttribute('data-code') || '';
    function done() {
      chip.classList.add('is-copied');
      setTimeout(function () { chip.classList.remove('is-copied'); }, 1600);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {});
    } else {
      var ta = document.createElement('textarea');
      ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      document.body.removeChild(ta);
    }
  });

  // ========================
  // HERO SLIDER
  // ========================
  document.querySelectorAll('[data-hero-slider]').forEach(function(slider) {
    var slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    var dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));

    if (slides.length === 0) return;

    var heroIndex = 0;
    var heroAutoplayId = null;
    var heroAutoplayMs = 5000;

    function updateHeroSlider(nextIndex) {
      heroIndex = nextIndex;

      slides.forEach(function(slide, index) {
        slide.classList.toggle('is-active', index === heroIndex);

        var videos = slide.querySelectorAll('video');
        if (!videos.length) return;

        videos.forEach(function(video) {
          if (index === heroIndex) {
            video.currentTime = 0;
            video.play().catch(function() {});
          } else {
            video.pause();
          }
        });
      });

      dots.forEach(function(dot, index) {
        dot.classList.toggle('is-active', index === heroIndex);
        dot.setAttribute('aria-current', index === heroIndex ? 'true' : 'false');
      });

      var dotsWrap = slider.querySelector('.hero__slider-dots');
      if (dotsWrap) {
        dotsWrap.classList.toggle('is-split-active', slides[heroIndex].dataset.heroSplit === 'true');
      }
    }

    function startHeroAutoplay() {
      clearInterval(heroAutoplayId);
      heroAutoplayId = setInterval(function() {
        var nextIndex = (heroIndex + 1) % slides.length;
        updateHeroSlider(nextIndex);
      }, heroAutoplayMs);
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        updateHeroSlider(Number(this.dataset.heroDot) || 0);
        startHeroAutoplay();
      });
    });

    var prevBtn = slider.querySelector('[data-hero-prev]');
    var nextBtn = slider.querySelector('[data-hero-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        updateHeroSlider((heroIndex - 1 + slides.length) % slides.length);
        startHeroAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        updateHeroSlider((heroIndex + 1) % slides.length);
        startHeroAutoplay();
      });
    }

    slider.addEventListener('mouseenter', function() {
      clearInterval(heroAutoplayId);
    });

    slider.addEventListener('mouseleave', function() {
      startHeroAutoplay();
    });

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        clearInterval(heroAutoplayId);
      } else {
        startHeroAutoplay();
      }
    });

    updateHeroSlider(0);
    startHeroAutoplay();
  });

  // ========================
  // HOMEPAGE SLIDER / BRAND CAROUSEL
  // ========================
  document.querySelectorAll('[data-homepage-slider]').forEach(function(slider) {
    var track = slider.querySelector('.homepage-slider__track');
    var cards = track ? Array.from(track.children) : [];
    var filters = slider.querySelectorAll('.homepage-slider__filter');

    if (!track || cards.length === 0) return;

    var activeFilter = 'all';
    var autoplayMs = 3400;
    var autoplayId = null;

    function applyFilter(filter) {
      activeFilter = filter;

      filters.forEach(function(btn) {
        btn.classList.toggle('is-active', btn.dataset.brandFilter === filter);
      });

      cards.forEach(function(card) {
        var category = (card.dataset.brandCategory || '').toLowerCase();
        var show = filter === 'all' || category === filter;
        card.style.display = show ? '' : 'none';
      });
    }

    function startAutoplay() {
      clearInterval(autoplayId);
      autoplayId = setInterval(function() {
        if (!track || track.scrollWidth <= track.clientWidth) return;

        var step = 260;
        if (window.innerWidth <= 640 && cards.length) {
          var firstCard = cards[0];
          var cardWidth = firstCard.getBoundingClientRect().width || 260;
          var gap = parseFloat(getComputedStyle(track).gap) || 14;
          step = cardWidth + gap;
        }

        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 12) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      }, autoplayMs);
    }

    filters.forEach(function(filterBtn) {
      filterBtn.addEventListener('click', function() {
        applyFilter(this.dataset.brandFilter || 'all');
        startAutoplay();
      });
    });

    track.addEventListener('mouseenter', function() {
      clearInterval(autoplayId);
    });

    track.addEventListener('mouseleave', function() {
      startAutoplay();
    });

    applyFilter(activeFilter);
    startAutoplay();
  });

  // ========================
  // PRODUCT SLIDER (Best Sellers / Trending)
  // ========================
  document.querySelectorAll('[data-product-slider]').forEach(function(slider) {
    var track = slider.querySelector('.product-slider__track');
    if (!track) return;

    function step() {
      var card = track.querySelector('.product-card');
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).gap) || 24;
      return card.getBoundingClientRect().width + gap;
    }

    // Manual navigation only — no autoplay. Arrows scroll one card at a time.
    var prevBtn = slider.querySelector('[data-product-slider-prev]');
    var nextBtn = slider.querySelector('[data-product-slider-next]');

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
  });

  // ========================
  // PRODUCT PAGE — Swatch carousel arrows + click handlers
  // ========================

  // Arrow scroll — only scrolls the viewport, no form interaction
  document.querySelectorAll('.pdp2-swatch-arrow').forEach(function(arrow) {
    arrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var vpId = this.dataset.vp;
      var vp = document.getElementById(vpId);
      if (!vp) return;
      var track = vp.querySelector('.pdp2-swatch-track');
      if (!track) return;
      var swatchW = 72 + 8; // swatch width + gap = 80px per step
      var current = track._offset || 0;
      var maxOffset = Math.max(0, track.scrollWidth - vp.offsetWidth);
      if (this.dataset.dir === 'next') {
        current = Math.min(current + swatchW * 4, maxOffset);
      } else {
        current = Math.max(current - swatchW * 4, 0);
      }
      track._offset = current;
      track.style.transform = 'translateX(-' + current + 'px)';
    });
  });

  // Swatch clicks are handled by the single PDP2 variant resolver further
  // down (search "PDP2 — Variant selection"), shared with the size pills.

  var allColFilters = document.querySelectorAll('.col-filter');
  document.querySelectorAll('.col-filter__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var thisFilter = this.closest('.col-filter');
      var wasCollapsed = thisFilter.classList.contains('is-collapsed');

      // Accordion — opening one filter group closes all the others
      allColFilters.forEach(function (filter) {
        if (filter === thisFilter) return;
        filter.classList.add('is-collapsed');
        var toggle = filter.querySelector('.col-filter__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });

      thisFilter.classList.toggle('is-collapsed', !wasCollapsed);
      this.setAttribute('aria-expanded', wasCollapsed.toString());
    });
  });

  // ========================
  // FRAME COLOR — "Show more" (Brand Collection pages only, long color lists)
  // ========================
  var colorShowMoreBtn = document.getElementById('col-color-show-more');
  if (colorShowMoreBtn) {
    colorShowMoreBtn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var extraItems = document.querySelectorAll('.col-filter__color-extra');
      extraItems.forEach(function(li) { li.hidden = expanded; });
      this.setAttribute('aria-expanded', (!expanded).toString());
      this.textContent = expanded ? 'Show more' : 'Show less';
    });
  }

  // ========================
  // BRAND — "Show more" (Brand Collection pages only, long brand lists)
  // ========================
  var brandShowMoreBtn = document.getElementById('col-brand-show-more');
  if (brandShowMoreBtn) {
    brandShowMoreBtn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var extraItems = document.querySelectorAll('.col-filter__brand-extra');
      extraItems.forEach(function(li) { li.hidden = expanded; });
      this.setAttribute('aria-expanded', (!expanded).toString());
      this.textContent = expanded ? 'Show more' : 'Show less';
    });
  }

  // ========================
  // MOBILE FILTER DRAWER — collection page sidebar as a slide-in panel
  // ========================
  (function () {
    var mobileFilterBtn = document.getElementById('col-mobile-filter-btn');
    var sidebar = document.getElementById('col-sidebar');
    var overlay = document.getElementById('col-mobile-filter-overlay');
    var closeBtn = document.getElementById('col-sidebar-close');
    if (!mobileFilterBtn || !sidebar || !overlay) return;

    function openDrawer() {
      sidebar.classList.add('is-drawer-open');
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      mobileFilterBtn.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      sidebar.classList.remove('is-drawer-open');
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      mobileFilterBtn.setAttribute('aria-expanded', 'false');
    }

    mobileFilterBtn.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-drawer-open')) closeDrawer();
    });

    var applyBtn = document.getElementById('apply-all-filters');
    if (applyBtn) applyBtn.addEventListener('click', closeDrawer);
  })();

  // ========================
  // MEN'S / WOMEN'S COLLECTIONS — shuffle the Unisex group
  // ========================
  // collection-main.liquid already renders gender-matched products first, then
  // Unisex products after (marked with data-gender-group="unisex") — this just
  // randomizes the Unisex block's order on each page view, so the Men's and
  // Women's collections (which share most of the same Unisex catalog) don't
  // show it in the exact same order as each other. Only runs on the two
  // collections that opt in via data-gender-reorder; every other collection
  // page is untouched.
  (function () {
    var genderGrid = document.getElementById('col-product-grid');
    if (!genderGrid || genderGrid.dataset.genderReorder !== 'true') return;
    var unisexCards = Array.prototype.slice.call(genderGrid.querySelectorAll('[data-gender-group="unisex"]'));
    if (unisexCards.length < 2) return;
    for (var i = unisexCards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = unisexCards[i]; unisexCards[i] = unisexCards[j]; unisexCards[j] = tmp;
    }
    // Re-appending moves each card to the end of the grid in shuffled order —
    // since the gender-matched cards were never touched, they stay first.
    unisexCards.forEach(function (card) { genderGrid.appendChild(card); });
  })();

  // ========================
  // INFINITE SCROLL — cards from templates/collection.cards*.liquid
  // ========================
  // Filter data (shape / frame color / lens / gender) for every product in a
  // collection, served by templates/collection.filter-data.liquid. Used by the
  // mega menu's filter lists. Resolves to { handle: { s, c, l, g } }, or null if
  // the request failed. Cached per collection.
  var collectionFilterDataCache = {};
  function loadCollectionFilterData(handle) {
    if (!handle) return Promise.resolve(null);
    if (collectionFilterDataCache[handle]) return collectionFilterDataCache[handle];
    function fetchPage(page) {
      return fetch('/collections/' + handle + '?view=filter-data&page=' + page, { credentials: 'same-origin' })
        .then(function(r) { if (!r.ok) throw new Error('filter-data ' + r.status); return r.text(); })
        .then(function(text) { return JSON.parse(text); });
    }
    collectionFilterDataCache[handle] = fetchPage(1)
      .then(function(first) {
        var map = first.products || {};
        var rest = [];
        for (var p = 2; p <= (first.pages || 1); p++) rest.push(fetchPage(p));
        return Promise.all(rest).then(function(pages) {
          pages.forEach(function(d) { Object.assign(map, d.products || {}); });
          return map;
        });
      })
      .catch(function() { delete collectionFilterDataCache[handle]; return null; });
    return collectionFilterDataCache[handle];
  }
  window.__loadCollectionFilterData = loadCollectionFilterData;

  var grid = document.getElementById('col-product-grid');
  var sentinel = document.getElementById('col-infinite-sentinel');
  var spinner = document.getElementById('col-loading-spinner');
  var filterDataEl = document.getElementById('col-filter-data');

  // The sort the shopper picked (?sort_by=...), or '' for the collection's own
  // "Featured" order. Shopify applies it server-side to the first page and to the
  // ?view=cards pages below; 'discount' isn't a Shopify sort and is applied in the
  // browser once every card is loaded (see "COLLECTION SORT").
  var collectionSort = '';
  try { collectionSort = new URLSearchParams(window.location.search).get('sort_by') || ''; } catch (e) {}

  // Inserts a card at the end of the grid, keeping the "no results" message last.
  function gridAppend(card) {
    var endMarker = document.getElementById('col-no-filter-results-msg');
    grid.insertBefore(card, endMarker && endMarker.parentNode === grid ? endMarker : null);
  }

  if (grid && sentinel && filterDataEl) {
    var colHandle = filterDataEl.dataset.collection;
    var cardsPage = 0; // last ?view=cards page appended (24 cards per page)
    var isLoading = false;
    var allLoaded = false; // the sentinel is only rendered when there's more than one page

    // If the initial batch of products doesn't fill the viewport (common
    // with wide/short browser windows), the sentinel is already "in view"
    // the instant the page loads — so the IntersectionObserver fires
    // immediately and the page cascades through extra pages before the
    // visitor has scrolled at all, no matter how small rootMargin is.
    // hasUserScrolled gates the trigger below so nothing loads until a
    // real scroll happens, regardless of how short the page is.
    var hasUserScrolled = false;
    window.addEventListener('scroll', function () { hasUserScrolled = true; }, { passive: true, once: true });

    // The IntersectionObserver alone decides when to load more — it only fires on
    // genuine enter/leave-viewport transitions, not repeatedly while the visitor
    // lingers near the bottom (an older scroll-position fallback did that and
    // caused flicker and duplicate loads).
    var io = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && hasUserScrolled && !isLoading && !allLoaded) {
        loadNextPage();
      }
    }, { rootMargin: '0px' });
    io.observe(sentinel);

    // Featured order on the Men's/Women's collections: each loaded batch is
    // grouped the same way the first page is — own-gender matches first, Unisex
    // after (shuffled). Cards carry data-gender-group="unisex" only in that case.
    var genderTarget = '';
    if (!collectionSort) {
      genderTarget = (colHandle === 'mens-collection') ? 'men' : (colHandle === 'womens-sungalsses') ? 'women' : '';
    }

    // Featured order only: Shopify's own collection sort clusters by brand (titles
    // start with the vendor name), so each loaded batch is round-robined across its
    // vendors to mix brands. Never applied to a sort the shopper picked.
    function interleaveByVendor(cards) {
      var groups = {};
      var vendorOrder = [];
      cards.forEach(function(card) {
        var v = card.dataset.vendor || '';
        if (!groups[v]) { groups[v] = []; vendorOrder.push(v); }
        groups[v].push(card);
      });
      if (vendorOrder.length <= 1) return cards;
      var result = [];
      var remaining = true;
      while (remaining) {
        remaining = false;
        vendorOrder.forEach(function(v) {
          if (groups[v].length) {
            result.push(groups[v].shift());
            remaining = true;
          }
        });
      }
      return result;
    }

    function existingHandles() {
      var handles = {};
      grid.querySelectorAll('.col-product-item').forEach(function(card) {
        if (card.dataset.handle) handles[card.dataset.handle] = true;
      });
      return handles;
    }

    // Appends a batch, skipping products already in the grid (pages overlap the
    // first, server-rendered page because they're a different size).
    function insertCards(cards, arrange) {
      var seen = existingHandles();
      var fresh = cards.filter(function(card) {
        if (seen[card.dataset.handle]) return false;
        seen[card.dataset.handle] = true;
        return true;
      });
      if (arrange && !collectionSort) {
        var ownCards = [];
        var unisexCards = [];
        fresh.forEach(function(card) {
          (genderTarget && card.dataset.genderGroup === 'unisex' ? unisexCards : ownCards).push(card);
        });
        for (var i = unisexCards.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = unisexCards[i]; unisexCards[i] = unisexCards[j]; unisexCards[j] = tmp;
        }
        fresh = interleaveByVendor(ownCards).concat(interleaveByVendor(unisexCards));
      }
      fresh.forEach(gridAppend);
      return fresh.length;
    }

    // One page of cards from ?view=cards (24) or ?view=cards-bulk (100), in the
    // current sort. Shopify rate-limits rapid storefront requests with 429, so
    // those are retried with backoff instead of silently skipping a page.
    function fetchCardsPage(view, page, attempt) {
      attempt = attempt || 0;
      var params = new URLSearchParams();
      params.set('view', view);
      params.set('page', page);
      if (collectionSort && collectionSort !== 'discount') params.set('sort_by', collectionSort);
      return fetch('/collections/' + colHandle + '?' + params.toString(), { credentials: 'same-origin' })
        .then(function(r) {
          if (r.ok) return r.text();
          if (r.status === 429 && attempt < 5) {
            return new Promise(function(resolve) { setTimeout(resolve, 1500 * Math.pow(2, attempt)); })
              .then(function() { return fetchCardsPage(view, page, attempt + 1); });
          }
          throw new Error('cards ' + r.status);
        })
        .then(function(result) {
          if (typeof result !== 'string') return result;
          var doc = new DOMParser().parseFromString(result, 'text/html');
          var wrap = doc.querySelector('[data-cards-pages]');
          if (!wrap) throw new Error('cards: unexpected response');
          return {
            pages: parseInt(wrap.dataset.cardsPages, 10) || 1,
            cards: Array.prototype.slice.call(wrap.querySelectorAll('.col-product-item')).map(function(card) {
              return document.importNode(card, true);
            })
          };
        });
    }

    function markAllLoaded() {
      allLoaded = true;
      if (io && typeof io.disconnect === 'function') io.disconnect();
      if (sentinel) sentinel.style.display = 'none';
      if (spinner) spinner.style.display = 'none';
    }

    // An IntersectionObserver only fires when the sentinel ENTERS the viewport. If a
    // load finishes (or fails) while the sentinel is still on screen, nothing would
    // ever trigger the next page — re-observing reports its current state again.
    function rearmInfiniteScroll() {
      if (allLoaded || !io || !sentinel) return;
      io.unobserve(sentinel);
      io.observe(sentinel);
    }

    function loadNextPage() {
      if (isLoading || allLoaded) return;
      isLoading = true;
      if (spinner) spinner.style.display = 'flex';

      fetchCardsPage('cards', cardsPage + 1)
        .then(function(result) {
          cardsPage++;
          insertCards(result.cards, true);

          if (window.__updateFilterAvailability && typeof window.__updateFilterAvailability === 'function') {
            window.__updateFilterAvailability();
          }
          if (window.__applyCollectionFilters && typeof window.__applyCollectionFilters === 'function') {
            window.__applyCollectionFilters();
          }

          isLoading = false;
          if (cardsPage >= result.pages) {
            markAllLoaded();
          } else {
            if (spinner) spinner.style.display = 'none';
            rearmInfiniteScroll();
            topUpFirstPage();
          }
        })
        .catch(function() {
          // Still failing after retries — the same page is requested again on the
          // next trigger instead of being skipped.
          isLoading = false;
          if (spinner) spinner.style.display = 'none';
          setTimeout(rearmInfiniteScroll, 3000);
        });
    }

    // Client-side filtering (brand/shape/color/etc.) and the Discount sort need
    // every product in the DOM — infinite scroll only loads a handful up front, so a
    // valid filter value whose products haven't scrolled in yet would wrongly show
    // "0 products found". This loads the rest at 100 cards per request, in the
    // current sort order, appending them after what's already shown. Resolves even
    // if loading fails, so filtering still runs on what's there.
    var allProductsLoadPromise = null;
    function ensureAllProductsLoaded() {
      if (allLoaded) return Promise.resolve();
      if (allProductsLoadPromise) return allProductsLoadPromise;

      if (io && typeof io.disconnect === 'function') io.disconnect();
      if (spinner) spinner.style.display = 'flex';

      allProductsLoadPromise = fetchCardsPage('cards-bulk', 1)
        .then(function(first) {
          var rest = [];
          for (var p = 2; p <= first.pages; p++) rest.push(fetchCardsPage('cards-bulk', p));
          return Promise.all(rest).then(function(pages) { return [first].concat(pages); });
        })
        .then(function(pages) {
          pages.forEach(function(page) { insertCards(page.cards, false); });
          markAllLoaded();
          if (window.__updateFilterAvailability && typeof window.__updateFilterAvailability === 'function') {
            window.__updateFilterAvailability();
          }
        })
        .catch(function() {
          if (spinner) spinner.style.display = 'none';
          allProductsLoadPromise = null;
          rearmInfiniteScroll();
        });

      return allProductsLoadPromise;
    }
    window.__ensureAllProductsLoaded = ensureAllProductsLoaded;

    // Products hidden server-side (e.g. Toronto Warehouse items outside Sale) are skipped
    // after Shopify has already split the collection into pages, so a page can render
    // short — or empty, when a sort puts many hidden products first (Men's by lowest
    // price showed 0 products). Until at least one full page of cards is in the grid,
    // keep loading the next batch straight away instead of waiting for a scroll.
    var firstPageSize = parseInt(filterDataEl.dataset.perPage, 10) || 9;
    function topUpFirstPage() {
      if (allLoaded || isLoading) return;
      if (grid.querySelectorAll('.col-product-item').length >= firstPageSize) return;
      loadNextPage();
    }
    topUpFirstPage();
  }

  // ========================
  // COLLECTION FILTER — Client-side filtering using product data attributes
  // ========================
  var sidebar = document.querySelector('.col-sidebar');
  var productGrid = document.getElementById('col-product-grid');

  if (sidebar && productGrid) {

    // Brand Collection pages (Dior, Gucci, Ray-Ban, etc.) are single-vendor
    // collections, so data-avail-brands only ever lists that one brand — the
    // availability check below would otherwise hide all 19 other brand options
    // as "unavailable". The Brand filter must always show every brand there so
    // the user can navigate to any of them.
    var isBrandCollectionPage = !!(filterDataEl && filterDataEl.dataset.isBrandCollection === 'true');
    // Auto-apply (filters apply instantly on click, no Apply button) — true for real
    // Brand Collection pages AND, by request, the Sale collection. Kept separate from
    // isBrandCollectionPage so Sale still gets the normal per-option availability
    // graying and never triggers the "clicking a brand navigates away" behavior below,
    // both of which are meant only for genuine single-vendor brand pages.
    var autoApplyFilters = !!(filterDataEl && filterDataEl.dataset.autoApplyFilters === 'true');

    // Disable (or hide, per CSS) any filter option whose value doesn't match
    // any currently-rendered product card. Reads the same metafield/tag-derived
    // data attributes applyFilters() itself uses, so availability and filtering
    // can never disagree with each other.
    function normFilterVal(s) {
      return (s || '').toLowerCase().trim()
        .replace(/\s*&\s*/g, ' & ')
        .replace(/[-_]+/g, ' ')
        .replace(/[^a-z0-9& ]+/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function updateFilterAvailability() {
      var avail = { brands: {}, shapes: {}, colors: {}, lens: {}, genders: {} };

      // Brand/Shape/Color/Lens/Gender availability all come from the server-computed
      // full-collection lists (data-avail-*, built in collection-main.liquid) — covering
      // every product in the collection, not just the page(s) loaded into the DOM so far.
      // Previously only Brand read from a server list; Shape/Color/Lens scanned ONLY the
      // product cards physically rendered in the DOM at that moment (the first page, often
      // just 9-24 products), which wrongly hid most Shape/Lens options as "unavailable"
      // before the shopper ever scrolled or clicked Apply — this was the actual root cause
      // of "Shape filter doesn't work" and "Polarized filter doesn't work".
      var filterDataForAvail = document.getElementById('col-filter-data');
      function seedFromServerList(bucket, attr) {
        var raw = filterDataForAvail ? (filterDataForAvail.dataset[attr] || '') : '';
        raw.split('|').forEach(function(v) {
          var nv = normFilterVal(v);
          if (nv) avail[bucket][nv] = true;
        });
      }
      seedFromServerList('brands', 'availBrands');
      seedFromServerList('shapes', 'availShapes');
      seedFromServerList('colors', 'availColors');
      seedFromServerList('lens', 'availLens');
      seedFromServerList('genders', 'availGenders');

      // Also merge in whatever's actually rendered in the DOM right now — covers cards
      // built client-side (infinite scroll / AJAX) whose values might not have made it
      // into the server-side aggregation (which is itself capped at Shopify's default
      // 50-product loop limit outside a paginate block).
      productGrid.querySelectorAll('.col-product-item').forEach(function(card) {
        var brand = normFilterVal(card.dataset.mfBrand || card.dataset.vendor);
        var shape = normFilterVal(card.dataset.mfShape);
        if (brand) avail.brands[brand] = true;
        if (shape) avail.shapes[shape] = true;
        // mf_color / mf_lens / mf_gender can each be a "|"-separated list of every value a
        // product offers — split before normalizing so each value registers on its own,
        // instead of merging into one unmatched blob.
        (card.dataset.mfColor || '').split('|').forEach(function(c) {
          var nc = normFilterVal(c);
          if (nc) avail.colors[nc] = true;
        });
        (card.dataset.mfLens || '').split('|').forEach(function(l) {
          var nl = normFilterVal(l);
          if (nl) avail.lens[nl] = true;
        });
        (card.dataset.mfGender || '').split('|').forEach(function(g) {
          var ng = normFilterVal(g);
          if (ng) avail.genders[ng] = true;
        });
      });

      document.querySelectorAll('.col-filter__tag-link[data-filter-type], .col-shape-pill[data-filter-type]').forEach(function(el) {
        if (el.classList.contains('is-active') || el.classList.contains('is-selected')) return;
        var type = el.dataset.filterType;
        if (isBrandCollectionPage && type === 'brands') {
          el.classList.remove('is-disabled');
          var brandLi = el.closest('li');
          if (brandLi) brandLi.classList.remove('is-disabled');
          return;
        }
        var set = avail[type];
        if (!set) return;
        var knownValues = Object.keys(set);
        if (knownValues.length === 0) { el.classList.remove('is-disabled'); return; }
        var value = normFilterVal(el.dataset.filterValue);
        var found = knownValues.some(function(v) {
          return v === value || v.indexOf(value) !== -1 || value.indexOf(v) !== -1;
        });
        var disabled = !found;
        el.classList.toggle('is-disabled', disabled);
        // Hide the wrapping <li> too — otherwise its flex gap still reserves
        // space for the now-invisible button, leaving a stack of blank gaps.
        var parentLi = el.closest('li');
        if (parentLi) parentLi.classList.toggle('is-disabled', disabled);
      });
    }

    updateFilterAvailability();
    // Infinite scroll can append cards for brands/shapes/colors not seen yet — re-check then
    window.__updateFilterAvailability = updateFilterAvailability;

    // Toggle filter selection — staged until Apply button is clicked
    document.querySelectorAll('.col-filter__tag-link[data-filter-type], .col-shape-pill[data-filter-type]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (this.classList.contains('is-disabled')) return;

        // Brand Collection pages: selecting a brand navigates straight to that
        // brand's own collection page instead of staging a client-side filter.
        if (isBrandCollectionPage && this.dataset.filterType === 'brands') {
          var brandHandle = this.dataset.brandHandle;
          if (brandHandle) window.location.href = '/collections/' + brandHandle;
          return;
        }

        var box = this.querySelector('.col-filter__check-box');

        // Auto-apply pages (real Brand Collection pages + Sale): every filter applies
        // immediately on click — no staging, no Apply button to press.
        if (autoApplyFilters) {
          var nowActive = !this.classList.contains('is-active');
          this.classList.toggle('is-active', nowActive);
          this.classList.remove('is-selected', 'is-deselected');
          if (box) box.classList.toggle('is-checked', nowActive);
          runAutoApply();
          return;
        }

        if (this.classList.contains('is-active')) {
          this.classList.remove('is-selected');
          this.classList.toggle('is-deselected');
          if (box) {
            box.classList.toggle('is-checked', !this.classList.contains('is-deselected'));
          }
        } else {
          this.classList.toggle('is-selected');
          this.classList.remove('is-deselected');
          if (box) {
            box.classList.toggle('is-checked', this.classList.contains('is-selected'));
          }
        }
      });
    });

    // Auto-apply pages have no Apply button — this commits whatever's
    // currently marked is-active straight away, same work the Apply click does
    // minus the "promote is-selected to is-active" step (already done at click time).
    function runAutoApply() {
      committedPriceMin = parseFloat(document.getElementById('price-min').value) || 0;
      committedPriceMax = parseFloat(document.getElementById('price-max').value) || Infinity;
      if (window.__ensureAllProductsLoaded && typeof window.__ensureAllProductsLoaded === 'function') {
        window.__ensureAllProductsLoaded().then(function() { applyFilters(); });
      } else {
        applyFilters();
      }
    }

    var applyBtn = document.getElementById('apply-all-filters');
    var clearBtn = document.getElementById('clear-all-filters');
    var noProductsMsg = document.getElementById('col-no-filter-results-msg');
    var countEl = document.getElementById('col-product-count');
    // The collection's full product count (collection.products_count, rendered into
    // #col-filter-data) — never less than what's actually in the grid.
    function collectionTotal(loadedCount) {
      var total = parseInt((filterDataEl && filterDataEl.dataset.total) || '0', 10) || 0;
      return Math.max(total, loadedCount);
    }
    var committedPriceMin = parseFloat(document.getElementById('price-min').value) || 0;
    var committedPriceMax = parseFloat(document.getElementById('price-max').value) || Infinity;

    // Auto-apply pages have no Apply button, so the Price range fields (which
    // normally only commit when Apply is clicked) auto-apply on change instead.
    if (autoApplyFilters) {
      ['price-min', 'price-max'].forEach(function(id) {
        var input = document.getElementById(id);
        if (input) input.addEventListener('change', runAutoApply);
      });
    }

    function getSelectedFilters() {
      var selected = { brands: [], shapes: [], colors: [], lens: [], genders: [] };

      document.querySelectorAll('.col-filter__tag-link.is-active:not(.is-deselected)[data-filter-type]').forEach(function(btn) {
        var type = btn.dataset.filterType;
        // Brand pages pre-tick their own brand as a marker (clicking a brand navigates
        // to that brand's page) — every product here is already that brand. Counting it
        // as a filter made the page look "filtered", which paused infinite scroll after
        // the first load (stuck at 18 products) and showed that loaded count as the total.
        if (isBrandCollectionPage && type === 'brands') return;
        var val = (btn.dataset.filterValue || '').toLowerCase().trim();
        if (selected[type] && val && !selected[type].includes(val)) selected[type].push(val);
      });

      document.querySelectorAll('.col-shape-pill.is-active:not(.is-deselected)[data-filter-type]').forEach(function(btn) {
        var val = (btn.dataset.filterValue || '').toLowerCase().trim();
        if (val && !selected.shapes.includes(val)) selected.shapes.push(val);
      });

      return selected;
    }

    function applyFilters() {
      var selected = getSelectedFilters();
      var priceMin = committedPriceMin;
      var priceMax = committedPriceMax;

      var hasFilters = selected.brands.length > 0 || selected.shapes.length > 0 ||
                       selected.colors.length > 0 || selected.lens.length > 0 ||
                       selected.genders.length > 0 ||
                       priceMin > 0 || priceMax < Infinity;

      function norm(s) {
        return (s || '').toLowerCase().trim()
          .replace(/\s*&\s*/g, ' & ')
          .replace(/[-_]+/g, ' ')
          .replace(/[^a-z0-9& ]+/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function wordMatch(productVal, filterVal) {
        var pv = norm(productVal);
        var fv = norm(filterVal);
        if (!pv || !fv) return false;
        return pv === fv || pv.split(/[\s,/]+/).some(function(word) { return word === fv; });
      }

      var products = productGrid.querySelectorAll('.col-product-item');
      var visibleCount = 0;

      products.forEach(function(card) {
        if (!hasFilters) {
          card.style.display = '';
          visibleCount++;
          return;
        }

        var vendor  = norm(card.dataset.vendor);
        var mfShape = norm(card.dataset.mfShape);
        var mfBrand = norm(card.dataset.mfBrand);
        var tags    = (card.dataset.tags || '').toLowerCase();
        var tagArr  = tags.split(',').map(function(t) { return t.trim(); });

        var show = true;

        if (selected.brands.length > 0) {
          var brandMatch = selected.brands.some(function(b) {
            var bn = norm(b);
            return norm(mfBrand) === bn || norm(vendor) === bn ||
                   wordMatch(mfBrand, b) || wordMatch(vendor, b);
          });
          if (!brandMatch) show = false;
        }

        if (show && selected.shapes.length > 0) {
          var shapeMatch = selected.shapes.some(function(s) {
            var sn = norm(s);
            return norm(mfShape) === sn ||
                   wordMatch(mfShape, s) ||
                   tagArr.some(function(t) { return norm(t) === sn; });
          });
          if (!shapeMatch) show = false;
        }

        if (show && selected.colors.length > 0) {
          // mf_color can carry multiple pipe-separated values (a product offering several
          // frame colors) — norm() strips the "|" separator entirely rather than treating
          // it as a boundary, so it must be split first or e.g. "rubber grey|matte black"
          // collapses into one unmatched blob.
          var colorValues = (card.dataset.mfColor || '').split('|').map(norm).filter(Boolean);
          var colorMatch = selected.colors.some(function(c) {
            var cn = norm(c);
            return colorValues.indexOf(cn) !== -1 ||
                   colorValues.some(function(cv) { return wordMatch(cv, c); }) ||
                   tagArr.some(function(t) { return norm(t) === cn; });
          });
          if (!colorMatch) show = false;
        }

        if (show && selected.lens.length > 0) {
          // mf_lens can carry multiple pipe-separated values (a product offering both
          // Polarized and Non Polarized variants) — norm() strips the "|" separator
          // entirely rather than treating it as a boundary, so it must be split first
          // or "polarized|non polarized" collapses into one unmatched blob.
          var lensValues = (card.dataset.mfLens || '').split('|').map(norm).filter(Boolean);
          var lensMatch = selected.lens.some(function(l) {
            var ln = norm(l);
            return lensValues.indexOf(ln) !== -1 ||
                   tagArr.some(function(t) {
                     return norm(t) === ln || norm(t).replace(/-/g, ' ') === ln;
                   });
          });
          if (!lensMatch) show = false;
        }

        if (show && selected.genders.length > 0) {
          // mf_gender can carry multiple pipe-separated values (a product offering both
          // Men's and Women's variants) — split before normalizing for the same reason
          // Color/Lens do above.
          var genderValues = (card.dataset.mfGender || '').split('|').map(norm).filter(Boolean);
          var genderMatch = selected.genders.some(function(g) {
            var gn = norm(g);
            return genderValues.indexOf(gn) !== -1 ||
                   tagArr.some(function(t) { return norm(t) === gn; });
          });
          if (!genderMatch) show = false;
        }

        if (show && (priceMin > 0 || priceMax < Infinity)) {
          var priceInDollars = parseInt(card.dataset.price || '0') / 100;
          if (priceInDollars < priceMin || priceInDollars > priceMax) show = false;
        }

        card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });

      // With no filter active, infinite scroll has usually loaded only part of the
      // collection — counting the cards in the DOM showed e.g. "18 products" for a
      // 58-product collection after scrolling. Show the collection's real total then;
      // only a filtered view (all products loaded first) shows the matching count.
      if (countEl) countEl.textContent = (hasFilters ? visibleCount : collectionTotal(visibleCount)) + ' products';
      if (noProductsMsg) noProductsMsg.style.display = (visibleCount === 0) ? 'flex' : 'none';
      // Pause infinite scroll while client-side filters are active, so it doesn't
      // keep appending unfiltered products underneath the filtered view.
      if (sentinel) sentinel.style.display = hasFilters ? 'none' : '';
      if (clearBtn) clearBtn.style.display = hasFilters ? 'block' : 'none';
    }

    // Expose filter reapply so infinite scroll can keep new cards hidden
    window.__applyCollectionFilters = applyFilters;

    // Applied filters as URL params — the sort dropdown carries them into its link
    // so they're re-applied after the page reloads in the new order (see below).
    window.__collectionFilterParams = function () {
      var selected = getSelectedFilters();
      return {
        brands: selected.brands.join(','),
        shapes: selected.shapes.join(','),
        colors: selected.colors.join(','),
        lens: selected.lens.join(','),
        genders: selected.genders.join(','),
        price_min: committedPriceMin > 0 ? String(committedPriceMin) : '',
        price_max: committedPriceMax < Infinity ? String(committedPriceMax) : ''
      };
    };

    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        sidebar.querySelectorAll('.col-filter__tag-link.is-selected').forEach(function(btn) {
          btn.classList.add('is-active');
          btn.classList.remove('is-selected');
          var box = btn.querySelector('.col-filter__check-box');
          if (box) box.classList.add('is-checked');
        });
        sidebar.querySelectorAll('.col-filter__tag-link.is-deselected').forEach(function(btn) {
          btn.classList.remove('is-active', 'is-selected', 'is-deselected');
          var box = btn.querySelector('.col-filter__check-box');
          if (box) box.classList.remove('is-checked');
        });
        document.querySelectorAll('.col-shape-pill.is-selected').forEach(function(btn) {
          btn.classList.add('is-active');
          btn.classList.remove('is-selected');
        });
        document.querySelectorAll('.col-shape-pill.is-deselected').forEach(function(btn) {
          btn.classList.remove('is-active', 'is-selected', 'is-deselected');
        });
        committedPriceMin = parseFloat(document.getElementById('price-min').value) || 0;
        committedPriceMax = parseFloat(document.getElementById('price-max').value) || Infinity;

        // Make sure every product in the collection is in the DOM before filtering —
        // otherwise a valid brand/shape/etc. that hasn't scrolled into view yet would
        // wrongly show "0 products found".
        if (window.__ensureAllProductsLoaded && typeof window.__ensureAllProductsLoaded === 'function') {
          applyBtn.disabled = true;
          window.__ensureAllProductsLoaded().then(function() {
            applyBtn.disabled = false;
            applyFilters();
          });
        } else {
          applyFilters();
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function(e) {
        e.preventDefault();
        sidebar.querySelectorAll('.col-filter__tag-link.is-selected, .col-filter__tag-link.is-active, .col-filter__tag-link.is-deselected').forEach(function(btn) {
          btn.classList.remove('is-selected', 'is-active', 'is-deselected');
          var box = btn.querySelector('.col-filter__check-box');
          if (box) box.classList.remove('is-checked');
        });
        document.querySelectorAll('.col-shape-pill.is-selected, .col-shape-pill.is-active, .col-shape-pill.is-deselected').forEach(function(btn) {
          btn.classList.remove('is-selected', 'is-active', 'is-deselected');
        });
        var priceMin = document.getElementById('price-min');
        var priceMax = document.getElementById('price-max');
        if (priceMin) priceMin.value = '';
        if (priceMax) priceMax.value = '';
        committedPriceMin = 0;
        committedPriceMax = Infinity;
        productGrid.querySelectorAll('.col-product-item').forEach(function(c) { c.style.display = ''; });
        if (noProductsMsg) noProductsMsg.style.display = 'none';
        if (clearBtn) clearBtn.style.display = 'none';
        if (sentinel && !allLoaded) sentinel.style.display = '';
        var total = productGrid.querySelectorAll('.col-product-item').length;
        if (countEl) countEl.textContent = collectionTotal(total) + ' products';
      });
    }

    // Do not auto-apply filters on page load for sidebar selections — except when the
    // page was opened from a link that already carries filters in the URL (e.g. the
    // Women / Men mega menu: ?shapes=round, ?colors=black, ?lens=polarized).
    // collection-main.liquid's request.params lookups never pre-tick anything (Shopify
    // Liquid has no request.params), so the matching sidebar boxes are ticked here,
    // their filter group is expanded, and the grid is filtered straight away.
    var urlFilters = new URLSearchParams(window.location.search);
    var urlFilterApplied = false;
    ['brands', 'shapes', 'colors', 'lens', 'genders'].forEach(function(type) {
      var raw = urlFilters.get(type);
      if (!raw) return;
      raw.split(',').forEach(function(v) {
        var wanted = v.toLowerCase().trim();
        if (!wanted) return;
        sidebar.querySelectorAll('.col-filter__tag-link[data-filter-type="' + type + '"]').forEach(function(btn) {
          if ((btn.dataset.filterValue || '').toLowerCase().trim() !== wanted) return;
          btn.classList.add('is-active');
          btn.classList.remove('is-selected', 'is-deselected', 'is-disabled');
          var box = btn.querySelector('.col-filter__check-box');
          if (box) box.classList.add('is-checked');
          var li = btn.closest('li');
          if (li) { li.classList.remove('is-disabled'); li.hidden = false; }
          var group = btn.closest('.col-filter');
          if (group) {
            group.classList.remove('is-collapsed');
            var toggle = group.querySelector('.col-filter__toggle');
            if (toggle) toggle.setAttribute('aria-expanded', 'true');
          }
          urlFilterApplied = true;
        });
      });
    });
    // Price range too (?price_min= / ?price_max=), as carried over by the sort dropdown.
    [['price_min', 'price-min'], ['price_max', 'price-max']].forEach(function(pair) {
      var raw = urlFilters.get(pair[0]);
      var input = document.getElementById(pair[1]);
      if (!raw || !input || isNaN(parseFloat(raw))) return;
      input.value = parseFloat(raw);
      var group = input.closest('.col-filter');
      if (group) {
        group.classList.remove('is-collapsed');
        var toggle = group.querySelector('.col-filter__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
      urlFilterApplied = true;
    });
    if (urlFilterApplied) runAutoApply();
  }

  // ========================
  // COLLECTION SORT — "Sort by" dropdown (snippets/collection-sort.liquid)
  // ========================
  // Options are plain ?sort_by= links, so Shopify renders the chosen order itself.
  // This opens/closes the panel and, on collection pages, carries the active filters
  // into the link so they're re-applied after the reload (filters live in the page,
  // not the URL, until then).
  (function () {
    var FILTER_PARAMS = ['brands', 'shapes', 'colors', 'lens', 'genders', 'price_min', 'price_max'];

    function sortUrl(value) {
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (value && value !== 'featured') url.searchParams.set('sort_by', value);
      else url.searchParams.delete('sort_by');
      if (typeof window.__collectionFilterParams === 'function') {
        var active = window.__collectionFilterParams();
        FILTER_PARAMS.forEach(function (key) {
          if (active[key]) url.searchParams.set(key, active[key]);
          else url.searchParams.delete(key);
        });
      }
      return url.pathname + url.search;
    }

    document.querySelectorAll('[data-sort-menu]').forEach(function (menu) {
      var toggle = menu.querySelector('.col-sort__toggle');
      var panel = menu.querySelector('.col-sort__panel');
      if (!toggle || !panel) return;
      var options = Array.prototype.slice.call(panel.querySelectorAll('.col-sort__option'));

      // The URL is the source of truth for which option is active — Liquid can't
      // tell "discount" apart (Shopify ignores that sort_by value).
      var current = (collectionSort || 'featured');
      var currentOption = options.filter(function (o) { return o.dataset.sortValue === current; })[0];
      if (currentOption) {
        options.forEach(function (o) {
          var on = o === currentOption;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var currentText = menu.querySelector('[data-sort-current]');
        var optionText = currentOption.querySelector('[data-sort-text]');
        if (currentText && optionText) currentText.textContent = optionText.textContent;
      }

      function open() {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        menu.classList.add('is-open');
        (panel.querySelector('.col-sort__option.is-active') || options[0]).focus();
      }
      function close(returnFocus) {
        if (panel.hidden) return;
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');
        if (returnFocus) toggle.focus();
      }

      toggle.addEventListener('click', function () {
        if (panel.hidden) open(); else close(false);
      });
      document.addEventListener('click', function (e) {
        if (!menu.contains(e.target)) close(false);
      });
      menu.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(true); return; }
        if (panel.hidden || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
        e.preventDefault();
        var idx = options.indexOf(document.activeElement);
        var next = e.key === 'ArrowDown' ? Math.min(options.length - 1, idx + 1) : Math.max(0, idx - 1);
        options[next].focus();
      });
      options.forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.preventDefault();
          close(false);
          if (option.classList.contains('is-active')) return;
          window.location.href = sortUrl(option.dataset.sortValue);
        });
      });
    });

    // Discount: highest % off first (cards carry data-discount from
    // snippets/collection-product-card.liquid), then lowest price, then the
    // collection's own order. Needs every product, so the rest are loaded first;
    // the grid is dimmed meanwhile so it doesn't visibly reshuffle.
    if (collectionSort === 'discount' && grid) {
      grid.classList.add('is-sorting');
      grid.setAttribute('aria-busy', 'true');
      var loadAll = typeof window.__ensureAllProductsLoaded === 'function' ? window.__ensureAllProductsLoaded() : Promise.resolve();
      loadAll.then(function () {
        Array.prototype.slice.call(grid.querySelectorAll('.col-product-item'))
          .map(function (card, i) {
            return { card: card, i: i, d: parseInt(card.dataset.discount, 10) || 0, p: parseInt(card.dataset.price, 10) || 0 };
          })
          .sort(function (a, b) { return (b.d - a.d) || (a.p - b.p) || (a.i - b.i); })
          .forEach(function (entry) { gridAppend(entry.card); });
        grid.classList.remove('is-sorting');
        grid.removeAttribute('aria-busy');
      });
    }
  })();

  // ========================
  // PRICE FILTER APPLY
  // ========================
  var priceApply = document.getElementById('apply-price-filter');
  if (priceApply) {
    priceApply.addEventListener('click', function () {
      var min = document.getElementById('price-min') ? document.getElementById('price-min').value : '';
      var max = document.getElementById('price-max') ? document.getElementById('price-max').value : '';
      var params = new URLSearchParams(window.location.search);
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      if (min) params.set('filter.v.price.gte', min);
      if (max) params.set('filter.v.price.lte', max);
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }

  // ========================
  // FAQ Accordion
  // ========================
  document.querySelectorAll('.faq-item__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('faq-item--open');
      document.querySelectorAll('.faq-item').forEach(function (el) {
        el.classList.remove('faq-item--open');
        el.querySelector('.faq-item__btn').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('faq-item--open');
        this.setAttribute('aria-expanded', 'true');
      }
      // Any answer that was expanded with "Read more" has just closed — it starts
      // collapsed again next time (FAQ section, below).
      document.querySelectorAll('.faq-section [data-faq-text].is-expanded').forEach(function (text) {
        setFaqExpanded(text, false);
      });
    });
  });

  // FAQ section (sections/faq.liquid), phones/tablets: an open answer shows 4 lines
  // (CSS line clamp) with "Read more" to see the rest. The button only appears when
  // the answer is actually longer than 4 lines, re-checked on resize/rotation.
  // Previously the open answer was cut off at a fixed 300px with no way to read on.
  function setFaqExpanded(text, expanded) {
    var more = text.parentNode.querySelector('[data-faq-more]');
    text.classList.toggle('is-expanded', expanded);
    if (more) {
      more.textContent = expanded ? 'Read less' : 'Read more';
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }
  function updateFaqReadMore() {
    document.querySelectorAll('.faq-section [data-faq-text]').forEach(function (text) {
      var more = text.parentNode.querySelector('[data-faq-more]');
      if (!more) return;
      if (text.classList.contains('is-expanded')) { more.hidden = false; return; }
      // Only clamped (and therefore taller than 4 lines) when the CSS clamp is active
      more.hidden = !(text.scrollHeight > text.clientHeight + 1);
    });
  }
  document.querySelectorAll('.faq-section [data-faq-more]').forEach(function (more) {
    more.addEventListener('click', function () {
      var text = more.parentNode.querySelector('[data-faq-text]');
      setFaqExpanded(text, !text.classList.contains('is-expanded'));
    });
  });
  if (document.querySelector('.faq-section [data-faq-text]')) {
    updateFaqReadMore();
    var faqResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(faqResizeTimer);
      faqResizeTimer = setTimeout(updateFaqReadMore, 150);
    });
    // Web fonts change line wrapping once they load.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateFaqReadMore);
  }

  // ========================
  // WHY CHOOSE US — "Looked after" card descriptions: clamp to 4 lines,
  // only show Read more when the text actually overflows that clamp.
  // ========================
  document.querySelectorAll('.why-care-item__desc-wrap').forEach(function (wrap) {
    var desc = wrap.querySelector('[data-care-desc]');
    var btn = wrap.querySelector('[data-care-readmore]');
    if (!desc || !btn) return;
    if (desc.scrollHeight > desc.clientHeight + 1) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var expanded = desc.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });
    }
  });

  // ========================
  // FOOTER ACCORDION — mobile only (Brands / Quick Links / Customer Care / Our Company)
  // ========================
  document.querySelectorAll('.footer-col__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var col = this.closest('.footer-col--accordion');
      if (!col) return;
      var isOpen = col.classList.toggle('is-open');
      this.setAttribute('aria-expanded', isOpen.toString());
    });
  });

  // ========================
  // Add to Cart (AJAX)
  // ========================
  document.querySelectorAll('.product-card__atc').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      var self = this;
      self.style.opacity = '0.6';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          updateCartCount();
          self.style.opacity = '1';
          // Brief visual feedback
          self.style.background = '#00a651';
          setTimeout(function () { self.style.background = ''; }, 800);
        })
        .catch(function (err) {
          console.error('Cart error:', err);
          self.style.opacity = '1';
        });
    });
  });

  // ========================
  // Update Cart Count
  // ========================
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  // ========================
  // Newsletter Form
  // ========================
  var newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = this.querySelector('.newsletter-form__input').value;
      if (!email) return;
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ 'contact[email]': email, form_type: 'customer' })
      }).then(function () {
        newsletterForm.innerHTML = '<p style="color:#fff;font-family:Manrope,sans-serif;font-size:18px;font-weight:600;text-align:center;padding:20px;">Thanks for subscribing!</p>';
      });
    });
  }

  // ========================
  // Mobile Menu
  // ========================
  var menuBtn = document.querySelector('.site-header__menu-btn');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileOverlay = document.querySelector('.mobile-nav__overlay');
  var mobileClose = document.querySelector('.mobile-nav__close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('mobile-nav--open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('mobile-nav--open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuBtn) menuBtn.addEventListener('click', openMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeSearch();
    }
  });
  // ========================
  // Search Modal
  // ========================
  var searchModal = document.querySelector('.search-modal');
  var searchOverlay = document.querySelector('.search-modal__overlay');
  var searchClose = document.querySelector('.search-modal__close');
  // querySelectorAll (not querySelector) — the mobile nav drawer now has its own
  // copy of this button (consolidating header icons behind the hamburger menu on
  // mobile), so more than one ".site-header__search-btn" can exist on the page.
  var searchBtns = document.querySelectorAll('.site-header__search-btn');
  var searchInput = document.querySelector('.search-modal__input');

  function openSearch() {
    if (!searchModal) return;
    closeMobileNav();
    searchModal.classList.add('open');
    searchModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 300);
  }

  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('open');
    searchModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  searchBtns.forEach(function (btn) { btn.addEventListener('click', openSearch); });
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  // ========================
  // Popular Searches — tracks per-device search frequency in localStorage and
  // re-ranks the "Popular:" tag row on the search page to match, so it stays
  // current with what's actually being searched instead of a fixed static list.
  // ========================
  (function () {
    var STORAGE_KEY = 'popularSearchTerms';

    function normalizeTerm(term) {
      return (term || '').toLowerCase().trim();
    }

    function recordSearchTerm(term) {
      term = normalizeTerm(term);
      if (!term) return;
      try {
        var counts = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        counts[term] = (counts[term] || 0) + 1;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(counts));
      } catch (e) { /* localStorage unavailable */ }
    }

    // Record a search whenever either search form is submitted (header modal or search page's own form)
    document.querySelectorAll('.search-modal__form, .search-banner__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[name="q"]');
        if (input) recordSearchTerm(input.value);
      });
    });

    var tagsWrap = document.getElementById('search-popular-tags');
    if (!tagsWrap) return;

    // Also count arriving on a results page directly (e.g. a shared link), not just form submits
    if (tagsWrap.dataset.currentTerm) recordSearchTerm(tagsWrap.dataset.currentTerm);

    var fallbackTags = (tagsWrap.dataset.fallbackTags || '').split(',')
      .map(function (t) { return t.trim(); }).filter(Boolean);
    var maxTags = parseInt(tagsWrap.dataset.maxTags, 10) || fallbackTags.length;
    var searchUrl = tagsWrap.dataset.searchUrl;

    var counts = {};
    try { counts = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) { counts = {}; }

    var rankedTerms = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });

    var finalTags = [];
    rankedTerms.concat(fallbackTags).forEach(function (t) {
      var norm = normalizeTerm(t);
      if (norm && finalTags.indexOf(norm) === -1 && finalTags.length < maxTags) finalTags.push(norm);
    });

    if (finalTags.length && searchUrl) {
      var label = tagsWrap.querySelector('.search-banner__tags-label');
      tagsWrap.innerHTML = '';
      if (label) tagsWrap.appendChild(label);
      finalTags.forEach(function (tag) {
        var a = document.createElement('a');
        a.className = 'search-banner__tag';
        a.href = searchUrl + '?type=product&q=' + encodeURIComponent(tag);
        a.textContent = tag;
        tagsWrap.appendChild(a);
      });
    }
  })();

  // ========================
  // Search Results — infinite scroll (mirrors the collection page's implementation)
  // ========================
  (function () {
    var searchGrid = document.getElementById('search-results-grid');
    var searchSentinel = document.getElementById('search-infinite-sentinel');
    var searchSpinner = document.getElementById('search-loading-spinner');
    if (!searchGrid || !searchSentinel) return;

    var searchTotal = parseInt(searchGrid.dataset.total, 10) || 0;
    var searchPerPage = parseInt(searchGrid.dataset.perPage, 10) || 8;
    var searchBaseUrl = searchGrid.dataset.baseUrl || '';
    var searchCurrentPage = 1;
    var searchMaxPages = Math.max(1, Math.ceil(searchTotal / searchPerPage));
    var searchIsLoading = false;
    var searchAllLoaded = searchMaxPages <= 1;
    var searchIO = null;

    if (!searchAllLoaded) {
      searchIO = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !searchIsLoading && !searchAllLoaded) {
          loadNextSearchPage();
        }
      }, { rootMargin: '300px' });
      searchIO.observe(searchSentinel);
    } else {
      searchSentinel.style.display = 'none';
    }

    function loadNextSearchPage() {
      if (searchIsLoading || searchAllLoaded) return;
      searchIsLoading = true;
      if (searchSpinner) searchSpinner.style.display = 'flex';
      searchCurrentPage++;

      if (searchCurrentPage > searchMaxPages) {
        searchAllLoaded = true;
        if (searchIO) searchIO.disconnect();
        if (searchSpinner) searchSpinner.style.display = 'none';
        searchSentinel.style.display = 'none';
        searchIsLoading = false;
        return;
      }

      var url = searchBaseUrl + (searchBaseUrl.indexOf('?') > -1 ? '&' : '?') + 'page=' + searchCurrentPage;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('search-results-grid');
          var newCards = newGrid ? newGrid.querySelectorAll('.product-card') : [];

          newCards.forEach(function (card) { searchGrid.appendChild(card); });

          if (!newCards.length || newCards.length < searchPerPage) {
            searchAllLoaded = true;
            if (searchIO) searchIO.disconnect();
            searchSentinel.style.display = 'none';
          }

          searchIsLoading = false;
          if (searchSpinner) searchSpinner.style.display = 'none';
        })
        .catch(function () {
          searchIsLoading = false;
          if (searchSpinner) searchSpinner.style.display = 'none';
        });
    }
  })();

  // ========================
  // Currency switcher — auto-select by visitor country on first load:
  //   US visitors  -> USD (leave as-is; Shopify's own geo-detection already
  //                   resolves localization.country to 'US' for them)
  //   CA visitors  -> CAD (leave as-is; already 'CA')
  //   Everyone else -> CAD (forced, same as the previous default-to-CAD
  //                   behavior for any other detected country)
  // Only runs once per visitor (guarded by the localStorage flag below) and
  // never overrides a currency the shopper already picked manually via the
  // switcher — the existing click handler further down still works exactly
  // as before.
  // ========================
  var currencyForm = document.getElementById('CurrencyForm');
  if (currencyForm) {
    var hasStoredPreference = false;
    try { hasStoredPreference = !!localStorage.getItem('currencyPreferenceSet'); } catch (e) { hasStoredPreference = true; }

    var countryInput = document.getElementById('CurrencyFormCountryInput');
    var currentCountry = countryInput ? countryInput.getAttribute('data-current-country') : null;
    var cadAvailable = countryInput ? countryInput.getAttribute('data-cad-available') === 'true' : false;

    if (cadAvailable && !hasStoredPreference && currentCountry !== 'CA' && currentCountry !== 'US') {
      try { localStorage.setItem('currencyPreferenceSet', '1'); } catch (e) {}
      if (countryInput) {
        countryInput.value = 'CA';
        currencyForm.submit();
      }
    } else {
      currencyForm.querySelectorAll('.currency-switcher__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          try { localStorage.setItem('currencyPreferenceSet', '1'); } catch (e) {}
        });
      });
    }

    // Dropdown open/close for the single-flag trigger.
    var currencyDropdown = currencyForm.querySelector('[data-currency-dropdown]');
    var currencyTrigger = currencyForm.querySelector('[data-currency-trigger]');
    if (currencyDropdown && currencyTrigger) {
      var closeCurrencyDropdown = function () {
        currencyDropdown.classList.remove('is-open');
        currencyTrigger.setAttribute('aria-expanded', 'false');
      };
      currencyTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = currencyDropdown.classList.toggle('is-open');
        currencyTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!currencyDropdown.contains(e.target)) closeCurrencyDropdown();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeCurrencyDropdown();
      });
    }
  }

  // ========================
  // Smooth scroll for anchor links
  // ========================
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ========================
  // Section animations disabled
  // Removed IntersectionObserver logic so sections render immediately
  // (Previously added section--animate / section--visible classes)
  // ========================

  // ========================
  // PRODUCT PAGE — Thumbnail Gallery
  // ========================
  var mainImg = document.getElementById('pdp-main-img');
  var thumbs  = document.querySelectorAll('.pdp-thumb');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = this.dataset.src;
      var alt = this.dataset.alt;
      if (mainImg && src) {
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = src;
          mainImg.alt = alt || '';
          mainImg.style.opacity = '1';
        }, 180);
      }
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  // ========================
  // PRODUCT PAGE — Variant Selection
  // ========================
  var pdpForm       = document.getElementById('pdp-form');
  var pdpVariantId  = document.getElementById('pdp-variant-id');
  var pdpPriceEl    = document.getElementById('pdp-price');
  var pdpAtcBtn     = document.getElementById('pdp-atc-btn');

  if (pdpForm && window.__pdpVariants) {
    var selectedOptions = [];

    // Initialise from active buttons
    document.querySelectorAll('.pdp-option').forEach(function(optEl) {
      var idx = parseInt(optEl.dataset.optionIndex);
      var activeBtn = optEl.querySelector('.pdp-opt-btn.is-active');
      selectedOptions[idx] = activeBtn ? activeBtn.dataset.value : '';
    });

    function findVariant() {
      return window.__pdpVariants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function updateVariantUI(variant) {
      if (!variant) return;
      // Update hidden variant ID
      if (pdpVariantId) pdpVariantId.value = variant.id;
      // Update price
      if (pdpPriceEl) {
        var price = (variant.price / 100).toFixed(2);
        pdpPriceEl.textContent = '$' + price;
      }
      // Update ATC button availability
      if (pdpAtcBtn) {
        if (variant.available) {
          pdpAtcBtn.disabled = false;
          pdpAtcBtn.textContent = 'Add to Cart';
        } else {
          pdpAtcBtn.disabled = true;
          pdpAtcBtn.textContent = 'Out of Stock';
        }
      }
    }

    document.querySelectorAll('.pdp-opt-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(this.dataset.optionIndex);
        var val = this.dataset.value;

        // Deselect siblings, select this
        var siblings = document.querySelectorAll('.pdp-opt-btn[data-option-index="' + idx + '"]');
        siblings.forEach(function(s) { s.classList.remove('is-active'); });
        this.classList.add('is-active');

        // Update label
        var label = document.getElementById('pdp-opt-val-' + idx);
        if (label) label.textContent = val;

        selectedOptions[idx] = val;

        var variant = findVariant();
        if (variant) updateVariantUI(variant);
      });
    });
  }

  // ========================
  // PRODUCT PAGE — Quantity Controls
  // ========================
  var qtyInput = document.getElementById('pdp-qty');
  var qtyMinus = document.getElementById('pdp-qty-minus');
  var qtyPlus  = document.getElementById('pdp-qty-plus');

  if (qtyInput) {
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value) || 1;
        qtyInput.value = v + 1;
      });
    }
  }

  // ========================
  // PRODUCT PAGE — AJAX Add to Cart
  // ========================
  if (pdpAtcBtn && pdpForm) {
    pdpForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = pdpVariantId ? pdpVariantId.value : null;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      if (!variantId) return;

      pdpAtcBtn.disabled = true;
      pdpAtcBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status) {
          // Error from Shopify
          pdpAtcBtn.disabled = false;
          pdpAtcBtn.textContent = data.description || 'Error — try again';
          return;
        }
        // Success
        pdpAtcBtn.textContent = '✓ Added!';
        pdpAtcBtn.style.background = '#00A651';
        updateCartCount();
        setTimeout(function() {
          pdpAtcBtn.disabled = false;
          pdpAtcBtn.textContent = 'Add to Cart';
          pdpAtcBtn.style.background = '';
        }, 1800);
      })
      .catch(function() {
        pdpAtcBtn.disabled = false;
        pdpAtcBtn.textContent = 'Error — try again';
      });
    });
  }

  // ========================
  // PRODUCT PAGE — Buy Now
  // ========================
  var buyNowBtn = document.getElementById('pdp-buy-now');
  if (buyNowBtn && pdpVariantId) {
    buyNowBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = pdpVariantId.value;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      if (variantId) {
        window.location.href = '/cart/' + variantId + ':' + qty;
      }
    });
  }

  // ========================
  // PDP2 — Thumbnail switching
  // ========================
  var pdpMainImg = document.getElementById('pdp2-main-img');
  var pdp2AllThumbs = document.querySelectorAll('.pdp2-thumb');

  // Warm the browser's cache with every full-size (1200w) gallery image right after
  // load, in the background. Previously the full-size image only started downloading
  // the instant a thumbnail was clicked — the fixed 150ms fade-out was just a timer,
  // not tied to the image actually being ready, so on anything slower than a fast
  // connection the swap would reveal a still-loading/blank image after that delay.
  // Preloading means the image is already in cache by the time it's clicked.
  pdp2AllThumbs.forEach(function(thumb) {
    if (!thumb.dataset.src) return;
    var preload = new Image();
    preload.src = thumb.dataset.src;
  });

  pdp2AllThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var newSrc = thumb.dataset.src;
      if (pdpMainImg && newSrc) {
        pdpMainImg.style.opacity = '0.3';
        // Only swap once the image has actually finished loading (it's usually
        // already cached from the preload above, so this resolves instantly) —
        // guarantees the fade-in never reveals a half-loaded/blank image.
        var loader = new Image();
        loader.onload = function() {
          pdpMainImg.src = newSrc;
          pdpMainImg.alt = thumb.dataset.alt || '';
          pdpMainImg.style.opacity = '1';
        };
        loader.onerror = function() {
          pdpMainImg.src = newSrc;
          pdpMainImg.style.opacity = '1';
        };
        loader.src = newSrc;
      }
      pdp2AllThumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // ========================
  // PDP2 — Variant selection
  // ========================
  var pdp2VariantId = document.getElementById('pdp2-variant-id');
  var pdp2PriceEl   = document.getElementById('pdp2-price');
  var pdp2AtcBtn    = document.getElementById('pdp2-atc-btn');
  var pdp2AtcLabel  = pdp2AtcBtn ? pdp2AtcBtn.querySelector('.pdp2-atc-btn__label') : null;
  var pdp2BuyNowBtn = document.getElementById('pdp2-buy-now');
  var pdp2QtyInput  = document.getElementById('pdp2-qty');

  function updatePdp2PriceUI(price, compareAtPrice) {
    var priceEl = document.getElementById('pdp2-price');
    if (priceEl && typeof price === 'number') priceEl.textContent = themeFormatMoney(price);

    // Sezzle pay-in-4 amount follows the selected variant's price
    var sezzleMirror = document.getElementById('pdp2-sezzle-price');
    if (sezzleMirror && typeof price === 'number') sezzleMirror.textContent = themeFormatMoney(price);
    var sezzleAmt = document.querySelector('#pdp2-sezzle [data-sezzle-installment]');
    if (sezzleAmt && typeof price === 'number') sezzleAmt.textContent = themeFormatMoney(Math.floor(price / 4));

    var wasEl = document.getElementById('pdp2-price-was');
    var saveEl = document.getElementById('pdp2-price-save');
    var onSale = typeof compareAtPrice === 'number' && compareAtPrice > price;
    if (wasEl) {
      wasEl.hidden = !onSale;
      if (onSale) wasEl.textContent = themeFormatMoney(compareAtPrice);
    }
    if (saveEl) {
      saveEl.hidden = !onSale;
      if (onSale) saveEl.textContent = 'Save ' + themeFormatMoney(compareAtPrice - price);
    }
  }

  function updatePdp2StockUI(available) {
    var row = document.getElementById('pdp2-stock-row');
    var text = document.getElementById('pdp2-stock-text');
    var icon = document.getElementById('pdp2-stock-icon');
    if (row) row.classList.toggle('is-out', !available);
    if (text) text.textContent = available ? 'In stock' : 'Out of stock';
    if (icon) {
      var circle = icon.querySelector('circle');
      var paths = icon.querySelectorAll('path');
      paths.forEach(function(p) { p.remove(); });
      var ns = 'http://www.w3.org/2000/svg';
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      path.setAttribute('d', available ? 'M6.5 10l2.5 2.5 4.5-4.5' : 'M7.5 7.5l5 5M12.5 7.5l-5 5');
      icon.appendChild(path);
    }
  }

  // Toggles the "Polarized" badge on the main product image to match whichever
  // variant is now selected. Accepts the already-resolved true/false directly
  // (see syncPdp2LensDisplays) instead of re-parsing text, so it can't disagree.
  function updatePdp2PolarizedBadge(isPolarized) {
    var badge = document.getElementById('pdp2-polarized-badge');
    if (!badge) return;
    badge.hidden = !isPolarized;
  }

  // Single source of truth for the main-image badge, the "Lense Type:" label, and
  // the "Polarized Clarity" section — all driven by vmeta.is_polarized, a definitive
  // true/false computed server-side per variant in product-main.liquid (same
  // fallback order as the SSR badge: variant metafield → product metafield → scan
  // that variant's own option values for "polarized"). Deriving this in the browser
  // from whatever raw text happened to be on hand after a swatch click was the
  // actual bug — it could disagree with Admin for variants whose metafield WAS set
  // correctly, since the click handler doesn't always resolve to the exact right
  // variant's own text. Reading the precomputed flag removes that guesswork.
  function syncPdp2LensDisplays(variantId, rawOptionValue) {
    var vmeta = window.__pdp2VariantMeta && window.__pdp2VariantMeta[variantId];
    var isPolarized = false;
    var lensType = vmeta && vmeta.lense_type ? vmeta.lense_type : '';
    if (vmeta && typeof vmeta.is_polarized === 'boolean') {
      isPolarized = vmeta.is_polarized;
      if (!lensType) lensType = isPolarized ? 'Polarized' : 'Non Polarized';
    } else {
      // No vmeta entry at all (shouldn't normally happen) — fall back to the
      // older text-based guess rather than showing nothing.
      if (!lensType && window.__pdp2ProductLenseType) lensType = window.__pdp2ProductLenseType;
      if (!lensType && rawOptionValue) {
        var rv = rawOptionValue.toLowerCase();
        var rvIsPolarized = rv.indexOf('polarized') !== -1 && rv.indexOf('non polarized') === -1 && rv.indexOf('non-polarized') === -1;
        lensType = rvIsPolarized ? 'Polarized' : 'Non Polarized';
      }
      var lt = (lensType || '').toLowerCase();
      isPolarized = lt.indexOf('polarized') !== -1 && lt.indexOf('non polarized') === -1 && lt.indexOf('non-polarized') === -1;
    }
    updatePdp2PolarizedBadge(isPolarized);
    // "Lense Type" label only appears at all when the variant IS polarized —
    // Non Polarized is the default assumption, so it's hidden otherwise.
    var lensWrapEl = document.getElementById('pdp2-lensetype-wrap');
    if (lensWrapEl) lensWrapEl.hidden = !isPolarized;
    var lensLabelEl = document.getElementById('pdp2-lensetype-badge');
    if (lensLabelEl) lensLabelEl.textContent = isPolarized ? 'Polarized' : 'Non Polarized';
    // "Polarized Clarity" lens-tech section (sections/product-lens-tech.liquid) —
    // only ever shown for a polarized variant, same condition as above.
    var lensTechSection = document.getElementById('pdp2-lens-tech-section');
    if (lensTechSection) lensTechSection.hidden = !isPolarized;
  }

  // Keeps the "Product Specification" modal/table in sync with whichever
  // variant is now selected — it used to be rendered once from the page's
  // initial/default variant and never update again, so switching color or
  // size left it showing stale values (e.g. "Size: L" after picking "XXL").
  // Only updates a row if it already exists in the DOM (rows are
  // conditionally rendered server-side when the default variant has a
  // value) and only if the new variant actually has a value for it, so a
  // field never gets blanked out just because the next variant lacks it.
  function updatePdp2SpecsModal(variantId) {
    var vmeta = window.__pdp2VariantMeta && window.__pdp2VariantMeta[variantId];
    if (!vmeta) return;
    var fields = [
      ['pdp2-spec-frame-color', vmeta.frame_color],
      ['pdp2-spec-lens-color', vmeta.lens_color],
      ['pdp2-spec-size', vmeta.size],
      ['pdp2-spec-frame-material', vmeta.frame_material],
      ['pdp2-spec-lens-material', vmeta.lenses_material],
      ['pdp2-spec-shape', vmeta.frame_shape],
      ['pdp2-spec-upc', vmeta.upc],
      ['pdp2-spec-lens-size', vmeta.lense_size],
      ['pdp2-spec-bridge-size', vmeta.bridge_size]
    ];
    fields.forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (el && pair[1]) el.textContent = pair[1];
    });
    var lensTypeEl = document.getElementById('pdp2-spec-lens-type');
    if (lensTypeEl) lensTypeEl.textContent = vmeta.is_polarized ? 'Polarized' : 'Non Polarized';
  }

  // ========================
  // PDP2 — Init gallery filter on page load
  // Filter thumbs to show only selected variant's own image group
  // ========================
  // Groups images by walking forward from the selected variant's OWN image
  // (matched by its stable raw src URL) up to — but not including — the next
  // image that is itself some OTHER variant's own assigned image. NOT by alt
  // text (alt is just the frame color name and is shared by every variant of
  // that color, e.g. "Black - Dark Grey" and "Black - Brown Photo" both have
  // alt "Black") and NOT by image position (Shopify reorders `product.images`
  // around whichever variant is server-selected, so position numbers captured
  // once at page load for every variant aren't reliably comparable against
  // each other — this was observed actually breaking on real products). A raw
  // src URL is stable no matter how the list gets reordered.
  function pdp2FilterGallery(variantId) {
    if (!window.__pdp2Images || window.__pdp2Images.length === 0) return;
    var variantSrcMap = window.__pdp2VariantImageSrc || {};
    var targetSrc = variantSrcMap[variantId];

    var matchedImgs = [];
    if (targetSrc) {
      var boundarySrcs = {};
      Object.keys(variantSrcMap).forEach(function(id) {
        var src = variantSrcMap[id];
        if (src && src !== targetSrc) boundarySrcs[src] = true;
      });

      var started = false;
      for (var i = 0; i < window.__pdp2Images.length; i++) {
        var img = window.__pdp2Images[i];
        if (!started) {
          if (img.rawSrc === targetSrc) started = true;
          else continue;
        }
        if (img.rawSrc !== targetSrc && boundarySrcs[img.rawSrc]) break;
        matchedImgs.push(img);
      }
    }

    if (matchedImgs.length === 0) return;

    var thumbsWrap = document.getElementById('pdp2-thumbs');
    if (!thumbsWrap) return;
    var thumbBtns = thumbsWrap.querySelectorAll('.pdp2-thumb');

    thumbBtns.forEach(function(thumb, i) {
      var img = thumb.querySelector('img');
      if (matchedImgs[i]) {
        if (img) img.src = matchedImgs[i].thumb;
        thumb.dataset.src = matchedImgs[i].src;
        thumb.style.display = '';
      } else {
        thumb.style.display = 'none';
      }
      thumb.classList.remove('is-active');
    });

    if (thumbBtns[0] && matchedImgs[0]) {
      thumbBtns[0].classList.add('is-active');
      var mainImg = document.getElementById('pdp2-main-img');
      // Preload before swapping — this used to assign mainImg.src directly, so
      // switching swatches showed a blank/half-loaded main image until the new
      // full-size (1200w) file finished downloading. Same fix as the thumbnail
      // click handler: wait for onload, then fade in.
      if (mainImg) {
        var newMainSrc = matchedImgs[0].src;
        mainImg.style.opacity = '0.3';
        var mainLoader = new Image();
        mainLoader.onload = function() {
          mainImg.src = newMainSrc;
          mainImg.style.opacity = '1';
        };
        mainLoader.onerror = function() {
          mainImg.src = newMainSrc;
          mainImg.style.opacity = '1';
        };
        mainLoader.src = newMainSrc;
      }
    }

    // Warm the cache for this variant's remaining angle shots (fr/lt/bk/cfr) in the
    // background, so clicking those thumbnails next is instant too.
    matchedImgs.forEach(function(img) {
      var preload = new Image();
      preload.src = img.src;
    });
  }

  // NOTE: this used to re-run pdp2FilterGallery() once on page load to narrow the
  // gallery down to the initially selected variant's own images. That's no longer
  // needed — product-main.liquid now renders the gallery pre-filtered to the right
  // variant from the start (see the position-range logic there). Calling it here
  // anyway would immediately re-fade the already-correct main image out and back
  // in (and re-request an image that's already on the page), which is exactly the
  // "takes a moment to load" flash this was meant to prevent.

  // ========================
  // PDP2 — Variant selection (colour swatches + size / other option pills)
  // ========================
  // One resolver for every option click. The requested combination is the
  // currently selected variant's options with the clicked value swapped in.
  // If that exact combination exists it is selected — even when sold out, so
  // the shopper sees it's sold out instead of being moved elsewhere. If it
  // doesn't exist (e.g. a colour that only comes in another size), the closest
  // variant that DOES have the clicked value is chosen — available first, then
  // the most options in common — and every other option's buttons visibly move
  // to match it. The hidden variant id, labels, price, gallery, stock, buttons
  // and URL are all set from that one variant object, so what's shown is
  // always exactly what gets submitted.
  //
  // This replaces two separate click handlers (swatches and pills) that could
  // disagree: a size pill with no matching variant used to highlight while the
  // form kept the previous variant id, and a colour landing on a missing
  // combination switched to a sold-out variant without disabling Add to Cart.
  var pdp2Variants = window.__pdp2Variants || [];
  var pdp2Current = null;
  var pdp2GallerySrc = null;
  if (pdp2VariantId && pdp2Variants.length) {
    pdp2Current = pdp2Variants.find(function (v) { return String(v.id) === String(pdp2VariantId.value); }) || null;
    if (pdp2Current && window.__pdp2VariantImageSrc) pdp2GallerySrc = window.__pdp2VariantImageSrc[pdp2Current.id] || null;
  }

  function pdp2OptionButtons() {
    return document.querySelectorAll('.pdp2-swatch-btn[data-option-index], .pdp2-opt-btn[data-option-index]');
  }

  function pdp2FindVariant(options) {
    return pdp2Variants.find(function (v) {
      return v.options.every(function (o, i) { return o === options[i]; });
    }) || null;
  }

  function pdp2Resolve(optionIndex, value) {
    if (!pdp2Current) return null;
    var wanted = pdp2Current.options.slice();
    wanted[optionIndex] = value;
    var exact = pdp2FindVariant(wanted);
    if (exact) return exact;
    var best = null, bestScore = -1;
    pdp2Variants.forEach(function (v) {
      if (v.options[optionIndex] !== value) return;
      var score = v.available ? 100 : 0;
      v.options.forEach(function (o, i) { if (i !== optionIndex && o === wanted[i]) score += 1; });
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  // '' = available with the current selection, 'sold-out' = that combination
  // (or every variant with this value) is sold out, 'unavailable' = this value
  // doesn't exist with the current selection but picking it will switch the
  // other option(s) to a combination that does.
  function pdp2OptionState(optionIndex, value) {
    if (!pdp2Current) return '';
    var wanted = pdp2Current.options.slice();
    wanted[optionIndex] = value;
    var exact = pdp2FindVariant(wanted);
    if (exact) return exact.available ? '' : 'sold-out';
    var anyAvailable = pdp2Variants.some(function (v) { return v.options[optionIndex] === value && v.available; });
    return anyAvailable ? 'unavailable' : 'sold-out';
  }

  function pdp2RefreshOptionStates() {
    if (!pdp2Current) return;
    var groupSizes = {};
    pdp2OptionButtons().forEach(function (btn) {
      groupSizes[btn.dataset.optionIndex] = (groupSizes[btn.dataset.optionIndex] || 0) + 1;
    });
    pdp2OptionButtons().forEach(function (btn) {
      var idx = parseInt(btn.dataset.optionIndex, 10);
      var value = btn.dataset.value;
      // A group with a single value (e.g. the only size) is never the reason a
      // combination is sold out, so it isn't marked — the other option and the
      // Out of Stock button already say so.
      var state = groupSizes[btn.dataset.optionIndex] > 1 ? pdp2OptionState(idx, value) : '';
      var isActive = pdp2Current.options[idx] === value;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      btn.classList.toggle('is-sold-out', state === 'sold-out');
      btn.classList.toggle('is-unavailable', state === 'unavailable');
      if (btn.dataset.baseLabel == null) btn.dataset.baseLabel = btn.getAttribute('aria-label') || btn.textContent.trim();
      var suffix = state === 'sold-out' ? ' — ' + themeString('optionSoldOut', 'Sold out')
        : (state === 'unavailable' ? ' — ' + themeString('optionUnavailable', 'Unavailable with current selection') : '');
      btn.setAttribute('aria-label', btn.dataset.baseLabel + suffix);
      if (btn.classList.contains('pdp2-swatch-btn')) btn.title = btn.dataset.baseLabel + suffix;
    });
  }

  // Option labels above each group, same text rules the server render uses.
  function pdp2UpdateOptionLabels(variant) {
    variant.options.forEach(function (value, idx) {
      var fullVal = value || '';
      var hiddenVal = document.getElementById('pdp2-opt-val-' + idx);
      var frameEl = document.getElementById('pdp2-opt-frame-' + idx);
      if (frameEl) {
        // Colour swatch group: "Frame/Lens" split, polarized suffix stripped.
        if (hiddenVal) hiddenVal.textContent = fullVal;
        var cleanVal = fullVal.split(' · ')[0].trim();
        cleanVal = cleanVal.replace(/ Polarized$/, '').replace(/ Non Polarized$/, '').replace(/ Non-Polarized$/, '').trim();
        var comboParts = cleanVal.split(' - ');
        frameEl.textContent = comboParts[0] ? comboParts[0].trim() : cleanVal;
        var lensEl = document.getElementById('pdp2-opt-lens-' + idx);
        if (lensEl) lensEl.textContent = comboParts[1] ? comboParts[1].trim() : '';
      } else if (hiddenVal && hiddenVal.dataset.isSize !== 'true') {
        hiddenVal.textContent = fullVal;
      }
      var fitBox = document.getElementById('pdp2-opt-fit-' + idx);
      if (fitBox) fitBox.textContent = fullVal;
    });
  }

  function pdp2ShowAtcError(message) {
    var el = document.getElementById('pdp2-atc-error');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function pdp2SetBuyState(available) {
    if (pdp2AtcBtn) {
      pdp2AtcBtn.disabled = !available;
      if (pdp2AtcLabel) {
        pdp2AtcLabel.textContent = available
          ? (pdp2AtcBtn.dataset.labelAdd || 'Add to Cart')
          : (pdp2AtcBtn.dataset.labelSoldOut || 'Out of Stock');
      }
      pdp2AtcBtn.style.background = '';
    }
    if (pdp2BuyNowBtn) pdp2BuyNowBtn.disabled = !available;
    updatePdp2StockUI(available);
  }

  function pdp2UpdateUrl(variant) {
    if (!window.history || !window.history.replaceState || !window.URL) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {}
  }

  function pdp2ApplyVariant(variant) {
    if (!variant) return;
    pdp2Current = variant;
    if (pdp2VariantId) pdp2VariantId.value = variant.id;
    pdp2UpdateOptionLabels(variant);
    pdp2RefreshOptionStates();
    // Lens displays fall back to scanning option text for "Polarized" only when
    // a variant has no precomputed entry — pass every option value for that.
    syncPdp2LensDisplays(variant.id, variant.options.join(' '));
    updatePdp2SpecsModal(variant.id);
    updatePdp2PriceUI(variant.price, variant.compare_at_price);
    pdp2SetBuyState(variant.available);
    pdp2ShowAtcError('');

    // Gallery: only re-filter when the variant's own photo actually changes
    // (e.g. a size switch within the same colour keeps the current gallery
    // instead of flashing it).
    var variantSrc = window.__pdp2VariantImageSrc ? window.__pdp2VariantImageSrc[variant.id] : null;
    if (variantSrc && variantSrc !== pdp2GallerySrc) {
      pdp2GallerySrc = variantSrc;
      pdp2FilterGallery(variant.id);
    }
    pdp2UpdateUrl(variant);
  }

  pdp2OptionButtons().forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variant = pdp2Resolve(parseInt(this.dataset.optionIndex, 10), this.dataset.value);
      if (variant) pdp2ApplyVariant(variant);
    });
  });

  // Initial load: the server already rendered the selected variant, so only
  // mark sold-out / unavailable options and sync the button states.
  if (pdp2Current) {
    pdp2RefreshOptionStates();
    if (pdp2BuyNowBtn) pdp2BuyNowBtn.disabled = !pdp2Current.available;
  }

  // ========================
  // PDP2 — Qty controls
  // ========================
  if (pdp2QtyInput) {
    var qm = document.getElementById('pdp2-qty-minus');
    var qp = document.getElementById('pdp2-qty-plus');
    if (qm) qm.addEventListener('click', function() { var v = parseInt(pdp2QtyInput.value) || 1; if (v > 1) pdp2QtyInput.value = v - 1; });
    if (qp) qp.addEventListener('click', function() { pdp2QtyInput.value = (parseInt(pdp2QtyInput.value) || 1) + 1; });
  }

  // ========================
  // PDP2 — Urgency count (auto-varies instead of a fixed number)
  // ========================
  var pdp2UrgencyCount = document.getElementById('pdp2-urgency-count');
  if (pdp2UrgencyCount) {
    var pdp2UrgencyMin = 50;
    var pdp2UrgencyMax = 89;
    pdp2UrgencyCount.textContent = Math.floor(Math.random() * (pdp2UrgencyMax - pdp2UrgencyMin + 1)) + pdp2UrgencyMin;
  }

  // ========================
  // PDP2 — Read more / less (short description)
  // ========================
  var pdp2ReadMoreBtn = document.getElementById('pdp2-readmore-btn');
  if (pdp2ReadMoreBtn) {
    pdp2ReadMoreBtn.addEventListener('click', function() {
      var wrap = document.getElementById('pdp2-short-desc');
      var expanded = wrap.classList.toggle('is-expanded');
      pdp2ReadMoreBtn.textContent = expanded ? 'Read less' : 'Read more';
    });
  }

  // ========================
  // PDP2 — AJAX Add to Cart
  // ========================
  // Always submits the variant in the hidden id input (which the resolver
  // above keeps in step with everything shown), refuses sold-out variants
  // up front, and shows Shopify's own error message under the button when
  // an add fails instead of a generic "Error — try again".
  function pdp2SelectedVariant() {
    var id = pdp2VariantId ? String(pdp2VariantId.value) : '';
    return pdp2Variants.find(function (v) { return String(v.id) === id; }) || null;
  }

  var pdp2Form = document.getElementById('pdp2-form');
  if (pdp2Form && pdp2AtcBtn) {
    pdp2Form.addEventListener('submit', function(e) {
      e.preventDefault();
      var variant = pdp2SelectedVariant();
      var qty = pdp2QtyInput ? parseInt(pdp2QtyInput.value) || 1 : 1;
      if (!variant) return;
      if (!variant.available) {
        pdp2SetBuyState(false);
        pdp2ShowAtcError(themeString('optionSoldOutMessage', 'This option is sold out. Please choose another.'));
        return;
      }
      pdp2ShowAtcError('');
      pdp2AtcBtn.disabled = true;
      if (pdp2BuyNowBtn) pdp2BuyNowBtn.disabled = true;
      if (pdp2AtcLabel) pdp2AtcLabel.textContent = 'Adding…';
      themeCartAdd(variant.id, qty)
        .then(function() {
          pdp2AtcBtn.style.background = '#00A651';
          if (pdp2AtcLabel) pdp2AtcLabel.textContent = '✓ Added!';
          if (typeof updateCartCount === 'function') updateCartCount();
          window.location.href = '/cart';
        })
        .catch(function(err) {
          pdp2SetBuyState(variant.available);
          pdp2ShowAtcError(err.message);
        });
    });
  }

  // ========================
  // PDP2 — Buy Now
  // ========================
  // Same behaviour as before (adds to the existing cart, then checkout), but
  // only continues to checkout when the add actually succeeded.
  if (pdp2BuyNowBtn && pdp2VariantId) {
    pdp2BuyNowBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var variant = pdp2SelectedVariant();
      var qty = pdp2QtyInput ? parseInt(pdp2QtyInput.value) || 1 : 1;
      if (!variant) return;
      if (!variant.available) {
        pdp2SetBuyState(false);
        pdp2ShowAtcError(themeString('optionSoldOutMessage', 'This option is sold out. Please choose another.'));
        return;
      }
      pdp2ShowAtcError('');
      pdp2BuyNowBtn.disabled = true;
      themeCartAdd(variant.id, qty)
        .then(function() {
          window.location.href = '/checkout';
        })
        .catch(function(err) {
          pdp2BuyNowBtn.disabled = false;
          pdp2ShowAtcError(err.message);
        });
    });
  }

  // ========================
  // CART PAGE — Live AJAX qty updates + remove
  // ========================
  // Each change asks Shopify to re-render this section in the same request
  // (Section Rendering API via `sections`), and the unit price, line total and
  // subtotal are copied from that fresh server render — so line-level
  // discounts, automatic discounts and price changes are always exactly what
  // Shopify calculated, never re-derived in the browser. If an update fails,
  // the cart is re-read from Shopify (falling back to the last confirmed
  // quantity if that fails too) and the reason is shown under that line.
  var cartForm = document.getElementById('cart-form');
  if (cartForm) {
    var cartSectionId = 'cart-main';

    function cartSetBusy(row, busy) {
      if (!row) return;
      row.style.opacity = busy ? '0.5' : '1';
      row.dataset.busy = busy ? '1' : '';
    }

    function cartShowRowError(row, message) {
      if (!row) return;
      var el = row.querySelector('.cart-item__error');
      if (!message) {
        if (el) el.remove();
        return;
      }
      if (!el) {
        el = document.createElement('p');
        el.className = 'cart-item__error';
        el.setAttribute('role', 'alert');
        var host = row.querySelector('.cart-item__qty') || row;
        host.appendChild(el);
      }
      el.textContent = message;
    }

    // The last quantity Shopify confirmed for each line — what a failed
    // update is rolled back to.
    cartForm.querySelectorAll('.cart-item__qty-input').forEach(function (input) {
      input.dataset.confirmedQty = input.value;
    });

    // Updates are sent ONE AT A TIME. Shopify can apply overlapping
    // /cart/change.js requests out of order, so firing them in parallel (as
    // rapid +/- clicks used to) could leave Shopify on an older quantity than
    // the one on screen. While a request is in flight, further clicks only
    // record the newest quantity wanted for that line; it's sent when the
    // queue reaches it, so Shopify always ends on the last quantity chosen.
    var cartQueue = Promise.resolve();
    var cartWanted = {}; // line key -> newest quantity not sent yet

    function cartIsPending(key) {
      return Object.prototype.hasOwnProperty.call(cartWanted, key);
    }

    function cartApplyCounts(count) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }

    // Copies unit price, line total, quantity and subtotal from a fresh server
    // render of this section. Lines with a newer change still waiting to be
    // sent keep what the shopper typed.
    function cartApplySection(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshForm = doc.getElementById('cart-form');
      if (!freshForm) return false;

      cartForm.querySelectorAll('.cart-item[data-key]').forEach(function (row) {
        var key = row.dataset.key;
        var pending = cartIsPending(key);
        var fresh = null;
        freshForm.querySelectorAll('.cart-item[data-key]').forEach(function (r) { if (r.dataset.key === key) fresh = r; });
        if (!fresh) { if (!pending) row.remove(); return; }
        ['.cart-item__price', '.cart-item__total'].forEach(function (sel) {
          var cur = row.querySelector(sel), next = fresh.querySelector(sel);
          if (cur && next) cur.innerHTML = next.innerHTML;
        });
        var freshInput = fresh.querySelector('.cart-item__qty-input');
        var input = row.querySelector('.cart-item__qty-input');
        if (freshInput && input) {
          input.dataset.confirmedQty = freshInput.value;
          if (!pending) input.value = freshInput.value;
        }
      });

      var subtotalEl = document.getElementById('cart-subtotal');
      var freshSubtotal = doc.getElementById('cart-subtotal');
      if (subtotalEl && freshSubtotal) subtotalEl.innerHTML = freshSubtotal.innerHTML;
      var cartSezzleMirror = document.getElementById('cart-sezzle-price');
      var freshMirror = doc.getElementById('cart-sezzle-price');
      if (cartSezzleMirror && freshMirror) cartSezzleMirror.textContent = freshMirror.textContent;
      var cartSezzleAmt = document.querySelector('#cart-sezzle [data-sezzle-installment]');
      var freshSezzleAmt = doc.querySelector('#cart-sezzle [data-sezzle-installment]');
      if (cartSezzleAmt && freshSezzleAmt) cartSezzleAmt.textContent = freshSezzleAmt.textContent;
      return true;
    }

    // Fallback when the response has no section HTML: same fields from the
    // cart JSON, formatted in the shopper's currency.
    function cartApplyJson(cart, key, row) {
      var updatedItem = cart.items.find(function(it) { return it.key === key; });
      if (!updatedItem || updatedItem.quantity === 0) {
        if (row && !cartIsPending(key)) row.remove();
      } else if (row) {
        var qtyInput = row.querySelector('.cart-item__qty-input');
        if (qtyInput) {
          qtyInput.dataset.confirmedQty = updatedItem.quantity;
          if (!cartIsPending(key)) qtyInput.value = updatedItem.quantity;
        }
        var totalEl = row.querySelector('.cart-item__total');
        if (totalEl) totalEl.textContent = themeFormatMoney(updatedItem.final_line_price);
      }
      var subtotalEl = document.getElementById('cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = themeFormatMoney(cart.total_price);
      var cartSezzleMirror = document.getElementById('cart-sezzle-price');
      if (cartSezzleMirror) cartSezzleMirror.textContent = themeFormatMoney(cart.total_price);
      var cartSezzleAmt = document.querySelector('#cart-sezzle [data-sezzle-installment]');
      if (cartSezzleAmt) cartSezzleAmt.textContent = themeFormatMoney(Math.floor(cart.total_price / 4));
    }

    // After a failed update, re-read the cart exactly as Shopify has it.
    // Shopify sometimes rejects a change yet still applies part of it (e.g.
    // capping a line at the available stock), so blindly restoring the old
    // number on screen could disagree with the real cart.
    function cartRefreshFromShopify() {
      // No JSON Accept header here: with one, /cart answers with the cart JSON
      // instead of the Section Rendering API's { "cart-main": html } map.
      return fetch('/cart?sections=' + cartSectionId)
        .then(function (r) { if (!r.ok) throw new Error('refresh ' + r.status); return r.json(); })
        .then(function (data) {
          if (!data || !data[cartSectionId] || !cartApplySection(data[cartSectionId])) throw new Error('refresh');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          cartApplyCounts(cart.item_count);
          if (cart.item_count === 0) window.location.reload();
        });
    }

    function cartSendChange(key, quantity, row) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: cartSectionId, sections_url: window.location.pathname })
      })
        .then(function(r) {
          return r.json().catch(function () { return {}; }).then(function (data) {
            if (!r.ok || !data || !Array.isArray(data.items)) {
              var msg = data && typeof data.description === 'string' && data.description ? data.description
                : (data && typeof data.message === 'string' && data.message ? data.message : '');
              throw new Error(msg || themeString('cartUpdateError', 'Could not update the quantity. Please try again.'));
            }
            return data;
          });
        })
        .then(function(cart) {
          var updatedItem = cart.items.find(function(it) { return it.key === key; });
          var html = cart.sections && cart.sections[cartSectionId];
          if (!(html && cartApplySection(html))) cartApplyJson(cart, key, row);
          cartApplyCounts(cart.item_count);
          if (cartIsPending(key)) return; // a newer change for this line is queued

          if (row && (!updatedItem || updatedItem.quantity === 0)) row.remove();
          cartSetBusy(row, false);
          // Shopify caps a line at the stock it can sell — say so instead of
          // silently showing a lower number than the shopper asked for.
          if (row && updatedItem && quantity > updatedItem.quantity) {
            cartShowRowError(row, themeString('cartQtyCapped', 'Only %q% available.').replace('%q%', updatedItem.quantity));
          } else {
            cartShowRowError(row, '');
          }
          if (cart.item_count === 0 && !Object.keys(cartWanted).length) window.location.reload();
        })
        .catch(function(err) {
          var message = err && err.message;
          return cartRefreshFromShopify()
            .catch(function () {
              // Couldn't reach Shopify at all — fall back to the last
              // quantity it confirmed for this line.
              var input = row ? row.querySelector('.cart-item__qty-input') : null;
              var confirmedQty = input ? parseInt(input.dataset.confirmedQty, 10) : NaN;
              if (input && !isNaN(confirmedQty) && !cartIsPending(key)) input.value = confirmedQty;
            })
            .then(function () {
              if (cartIsPending(key)) return;
              cartSetBusy(row, false);
              cartShowRowError(row, message);
            });
        });
    }

    function cartUpdateLine(key, quantity, row) {
      var alreadyQueued = cartIsPending(key);
      cartWanted[key] = quantity;
      cartSetBusy(row, true);
      if (alreadyQueued) return;
      cartQueue = cartQueue.then(function () {
        var qty = cartWanted[key];
        delete cartWanted[key];
        return cartSendChange(key, qty, row);
      });
    }

    document.querySelectorAll('.cart-item__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var row = this.closest('.cart-item');
        var input = row ? row.querySelector('.cart-item__qty-input') : null;
        if (!input) return;
        var v = parseInt(input.value) || 0;
        var newQty = this.dataset.action === 'plus' ? v + 1 : Math.max(0, v - 1);
        input.value = newQty;
        cartUpdateLine(this.dataset.key, newQty, row);
      });
    });

    document.querySelectorAll('.cart-item__qty-input').forEach(function(input) {
      input.addEventListener('change', function() {
        var v = Math.max(0, parseInt(this.value) || 0);
        this.value = v;
        cartUpdateLine(this.dataset.key, v, this.closest('.cart-item'));
      });
    });

    document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        cartUpdateLine(this.dataset.key, 0, this.closest('.cart-item'));
      });
    });

    // Discount codes are no longer handled on the cart page at all (see
    // sections/cart-main.liquid's "cart-discount-note") — the cart's classic
    // Cart API has no way to validate/apply a code, so shoppers are simply
    // told to enter it at Checkout, where Shopify handles it for real.
  }

  // ========================
  // CARD VARIANTS — colour swatches + Add to Cart on product cards
  // ========================
  // Markup comes from snippets/card-swatches.liquid — on every collection card,
  // including those added by infinite scroll (templates/collection.cards*.liquid)
  // — and carries the product's variants as JSON inside the card.
  // One delegated listener handles every card, so cards added later work too
  // and no card's state can leak into another's: everything is read from and
  // written to the clicked card only.
  //
  // Add to Cart rules (per selected colour):
  //   no purchasable variant     → button disabled ("Sold Out")
  //   exactly one purchasable    → added directly; the added variant is named
  //   more than one purchasable  → size chooser; sold-out sizes shown disabled
  function cardVariantsData(box) {
    if (!box._cardVariants) {
      try {
        box._cardVariants = JSON.parse(box.querySelector('[data-card-variants-json]').textContent);
      } catch (e) {
        box._cardVariants = [];
      }
    }
    return box._cardVariants;
  }

  function cardVariantsForColor(box, color) {
    var idx = parseInt(box.dataset.colorIndex, 10) || 0;
    return cardVariantsData(box).filter(function (v) { return v.o[idx] === color; });
  }

  // Everything except the colour, e.g. "M" — used for size buttons and the
  // "Added: …" confirmation.
  function cardVariantName(box, v, includeColor) {
    var idx = parseInt(box.dataset.colorIndex, 10) || 0;
    return v.o.filter(function (o, i) { return includeColor || i !== idx; })
      .filter(function (o) { return o && o !== 'Default Title'; }).join(' / ');
  }

  function cardShowMsg(box, text) {
    var msg = box.querySelector('[data-card-msg]');
    if (!msg) return;
    clearTimeout(box._cardMsgTimer);
    msg.textContent = text || '';
    msg.hidden = !text;
    if (text) box._cardMsgTimer = setTimeout(function () { msg.hidden = true; }, 4000);
  }

  // Writes into the button's text span so its bag icon is kept.
  function cardSetAtcText(atc, text) {
    var label = atc.querySelector('[data-card-atc-text]');
    if (label) label.textContent = text;
    else atc.textContent = text;
  }

  function cardSetAtcState(box) {
    var atc = box.querySelector('[data-card-atc]');
    if (!atc) return;
    var avail = cardVariantsForColor(box, box.dataset.activeColor).filter(function (v) { return v.a; });
    atc.disabled = avail.length === 0;
    cardSetAtcText(atc, avail.length ? themeString('cardAdd', 'Add to Cart') : themeString('cardSoldOut', 'Sold Out'));
  }

  function cardCloseChooser(box, restoreFocus) {
    var chooser = box.querySelector('[data-card-chooser]');
    if (!chooser || chooser.hidden) return;
    chooser.hidden = true;
    chooser.innerHTML = '';
    var atc = box.querySelector('[data-card-atc]');
    if (atc) atc.setAttribute('aria-expanded', 'false');
    if (restoreFocus && atc) atc.focus();
  }

  function cardSelectColor(box, color) {
    box.dataset.activeColor = color;
    box.querySelectorAll('[data-card-swatch]').forEach(function (s) {
      var on = s.dataset.value === color;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    cardCloseChooser(box, false);
    cardShowMsg(box, '');

    var variants = cardVariantsForColor(box, color);
    if (!variants.length) return;
    var avail = variants.filter(function (v) { return v.a; });
    var shown = avail[0] || variants[0];
    var priced = avail.length ? avail : variants;
    var card = box.closest('.product-card');
    if (!card) return;

    var img = card.querySelector('.product-card__image-wrap > img');
    if (img && shown.img) {
      img.removeAttribute('srcset');
      img.src = shown.img;
    }

    var min = Math.min.apply(null, priced.map(function (v) { return v.p; }));
    var varies = priced.some(function (v) { return v.p !== min; });
    var compares = priced.map(function (v) { return v.c; }).filter(function (c) { return c > 0; });
    var compare = compares.length ? Math.min.apply(null, compares) : 0;
    var priceEl = card.querySelector('.product-card__price');
    if (priceEl) {
      var priceText = varies ? themeString('cardFrom', 'From %p%').replace('%p%', themeFormatMoney(min)) : themeFormatMoney(min);
      priceEl.innerHTML = (compare > min ? '<span class="product-card__price-compare">' + themeFormatMoney(compare) + '</span>' : '') + priceText;
    }
    var sezzleAmt = card.querySelector('[data-sezzle-installment]');
    if (sezzleAmt) sezzleAmt.textContent = themeFormatMoney(Math.floor(min / 4));

    // Product links open the product page on this colour.
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var href = a.getAttribute('href').split('?')[0];
      a.setAttribute('href', href + '?variant=' + shown.id);
    });

    cardSetAtcState(box);
  }

  function cardAdd(box, variant, trigger) {
    var atc = box.querySelector('[data-card-atc]');
    var buttons = box.querySelectorAll('[data-card-atc], [data-card-size]');
    buttons.forEach(function (b) { b.disabled = true; });
    if (trigger && trigger === atc) cardSetAtcText(atc, themeString('cardAdding', 'Adding…'));
    else if (trigger) trigger.textContent = themeString('cardAdding', 'Adding…');
    cardShowMsg(box, '');
    themeCartAdd(variant.id, 1)
      .then(function () {
        cardCloseChooser(box, false);
        if (typeof updateCartCount === 'function') updateCartCount();
        if (atc) {
          atc.disabled = true;
          atc.classList.add('is-added');
          cardSetAtcText(atc, '✓ ' + themeString('cardAdded', 'Added'));
        }
        cardShowMsg(box, themeString('cardAddedVariant', 'Added: %v%').replace('%v%', cardVariantName(box, variant, true)));
        setTimeout(function () {
          if (atc) atc.classList.remove('is-added');
          cardSetAtcState(box);
        }, 2200);
      })
      .catch(function (err) {
        cardSetAtcState(box);
        box.querySelectorAll('[data-card-size]').forEach(function (b) {
          b.disabled = b.dataset.available !== 'true';
          b.textContent = b.dataset.name;
        });
        cardShowMsg(box, err.message);
      });
  }

  function cardOpenChooser(box, variants) {
    var chooser = box.querySelector('[data-card-chooser]');
    var atc = box.querySelector('[data-card-atc]');
    if (!chooser) return;
    var html = '<div class="card-variants__chooser-head"><span>' + escCardHtml(themeString('cardChooseSize', 'Select size')) + '</span>' +
      '<button type="button" class="card-variants__chooser-close" data-card-chooser-close aria-label="' + escCardHtml(themeString('cardClose', 'Close size options')) + '">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M11 3L3 11M3 3l8 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>' +
      '<div class="card-variants__sizes">';
    variants.forEach(function (v) {
      var name = cardVariantName(box, v, false) || cardVariantName(box, v, true);
      var label = v.a ? name : name + ' — ' + themeString('optionSoldOut', 'Sold out');
      html += '<button type="button" class="card-variants__size' + (v.a ? '' : ' is-sold-out') + '" data-card-size data-variant-id="' + v.id + '"' +
        ' data-available="' + (v.a ? 'true' : 'false') + '" data-name="' + escCardHtml(name) + '" aria-label="' + escCardHtml(label) + '"' +
        (v.a ? '' : ' disabled') + '>' + escCardHtml(name) + '</button>';
    });
    html += '</div>';
    chooser.innerHTML = html;
    chooser.hidden = false;
    if (atc) atc.setAttribute('aria-expanded', 'true');
    var first = chooser.querySelector('[data-card-size]:not([disabled])');
    if (first) first.focus();
  }

  function escCardHtml(str) {
    return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-card-swatch]');
    var atc = !swatch && e.target.closest('[data-card-atc]');
    var size = !swatch && !atc && e.target.closest('[data-card-size]');
    var close = !swatch && !atc && !size && e.target.closest('[data-card-chooser-close]');
    var box = (swatch || atc || size || close) ? (swatch || atc || size || close).closest('[data-card-variants]') : null;

    // Clicking anywhere else closes any open size chooser.
    document.querySelectorAll('[data-card-chooser]:not([hidden])').forEach(function (c) {
      var owner = c.closest('[data-card-variants]');
      if (owner !== box && !c.contains(e.target)) cardCloseChooser(owner, false);
    });
    if (!box) return;
    e.preventDefault();

    if (swatch) {
      cardSelectColor(box, swatch.dataset.value);
    } else if (atc) {
      var chooser = box.querySelector('[data-card-chooser]');
      if (chooser && !chooser.hidden) { cardCloseChooser(box, false); return; }
      var variants = cardVariantsForColor(box, box.dataset.activeColor);
      var avail = variants.filter(function (v) { return v.a; });
      if (avail.length === 1) cardAdd(box, avail[0], atc);
      else if (avail.length > 1) cardOpenChooser(box, variants);
    } else if (size) {
      var variant = cardVariantsData(box).find(function (v) { return String(v.id) === size.dataset.variantId; });
      if (variant && variant.a) cardAdd(box, variant, size);
    } else if (close) {
      cardCloseChooser(box, true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-card-chooser]:not([hidden])');
    if (open) cardCloseChooser(open.closest('[data-card-variants]'), true);
  });


  // ========================
  // Product card wishlist toggle — persists saved products in a first-party
  // cookie (NOT localStorage), storing only the lightweight {id, handle} pair
  // per item to stay well under typical cookie size limits. The /pages/wishlist
  // page fetches each saved product's live title/image/price from Shopify's own
  // /products/{handle}.js endpoint when it renders, rather than caching that
  // data client-side. Uses one delegated click listener (instead of per-button
  // listeners) so it also works on cards rendered dynamically after page load
  // (search results, homepage slider, infinite scroll). The button sits inside
  // .product-card__img-link, so a click would otherwise just navigate to the
  // product page — prevented here.
  // ========================
  (function () {
    var COOKIE_NAME = 'cs_wishlist';
    var COOKIE_MAX_AGE_DAYS = 365;

    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }

    function setCookie(name, value, days) {
      var maxAge = days * 24 * 60 * 60;
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    }

    function getWishlist() {
      try { return JSON.parse(getCookie(COOKIE_NAME) || '[]'); }
      catch (e) { return []; }
    }

    function saveWishlist(items) {
      // Only id + handle are persisted — everything else (title/image/price) is
      // looked up fresh from Shopify when the wishlist page renders.
      var slim = items.map(function (it) { return { id: it.id, handle: it.handle }; });
      setCookie(COOKIE_NAME, JSON.stringify(slim), COOKIE_MAX_AGE_DAYS);
      updateWishlistCount(slim);
    }

    function updateWishlistCount(items) {
      items = items || getWishlist();
      document.querySelectorAll('.wishlist-count').forEach(function (el) {
        el.textContent = items.length;
        el.hidden = items.length === 0;
      });
    }

    function applyWishlistState() {
      var items = getWishlist();
      var ids = items.map(function (it) { return String(it.id); });
      document.querySelectorAll('.product-card__wishlist, .pdp2-wishlist-btn').forEach(function (btn) {
        var id = btn.dataset.productId;
        btn.classList.toggle('is-active', !!(id && ids.indexOf(id) !== -1));
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-card__wishlist, .pdp2-wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var id = btn.dataset.productId;
      if (!id) return;

      var items = getWishlist();
      var idx = items.findIndex(function (it) { return String(it.id) === String(id); });
      var nowActive;
      if (idx === -1) {
        items.push({ id: id, handle: btn.dataset.handle || '' });
        nowActive = true;
      } else {
        items.splice(idx, 1);
        nowActive = false;
      }
      saveWishlist(items);

      document.querySelectorAll('.product-card__wishlist, .pdp2-wishlist-btn').forEach(function (otherBtn) {
        if (otherBtn.dataset.productId === id) {
          otherBtn.classList.toggle('is-active', nowActive);
        }
      });

      if (window.__renderWishlistPage && typeof window.__renderWishlistPage === 'function') {
        window.__renderWishlistPage();
      }
    });

    applyWishlistState();
    updateWishlistCount();
    // Re-apply after any dynamically rendered cards are inserted (search, slider).
    var wishlistObserver = new MutationObserver(function () { applyWishlistState(); });
    wishlistObserver.observe(document.body, { childList: true, subtree: true });

    window.__getWishlist = getWishlist;
    window.__saveWishlist = saveWishlist;
  })();

  // ========================
  // WISHLIST PAGE — reads the saved {id, handle} pairs from the cookie, then
  // fetches each product's current title/image/price live from Shopify via
  // /products/{handle}.js so the page always shows up-to-date info (and needs
  // no client-side cache of product data at all).
  // ========================
  (function () {
    var wishlistGrid = document.getElementById('wishlist-grid');
    if (!wishlistGrid) return;

    var emptyState = document.getElementById('wishlist-empty');

    function escHtmlWl(str) {
      return (str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    function moneyWl(cents) {
      cents = parseInt(cents, 10) || 0;
      return '$' + (cents / 100).toFixed(2);
    }

    function buildCardHtml(product) {
      var variant = (product.variants && product.variants[0]) || {};
      var priceHtml = (variant.compare_at_price && variant.compare_at_price > variant.price)
        ? '<span class="product-card__price-compare">' + moneyWl(variant.compare_at_price) + '</span>' + moneyWl(variant.price)
        : moneyWl(variant.price);
      // Unlike Shopify's /collections/{handle}/products.json, the
      // /products/{handle}.js endpoint used below returns `images`/`featured_image` as
      // plain URL strings, not objects with a `.src` — reading `.src` off a string is
      // always undefined, so this deliberately does not do that.
      var imgSrc = (product.images && product.images[0]) || product.featured_image || '';
      var imgHtml = imgSrc
        ? '<img src="' + escHtmlWl(imgSrc) + '" alt="' + escHtmlWl(product.title) + '" width="400" height="300" loading="lazy">'
        : '<div class="product-card__placeholder"></div>';

      return [
        '<a href="/products/', escHtmlWl(product.handle), '" class="product-card__img-link">',
          '<div class="product-card__image-wrap">', imgHtml,
            '<button class="product-card__wishlist is-active" type="button" aria-label="Remove from wishlist" data-product-id="', product.id, '">',
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none">',
                '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="#666" stroke-width="1.5" fill="none"/>',
              '</svg>',
            '</button>',
          '</div>',
        '</a>',
        '<div class="product-card__info">',
          '<p class="product-card__brand">', escHtmlWl((product.vendor || '').toUpperCase()), '</p>',
          '<h3 class="product-card__title"><a href="/products/', escHtmlWl(product.handle), '">', escHtmlWl(product.title), '</a></h3>',
          '<p class="product-card__price">', priceHtml, '</p>',
          sezzleCardHtml(variant.price),
        '</div>'
      ].join('');
    }

    function renderWishlistPage() {
      var items = (window.__getWishlist && window.__getWishlist()) || [];

      if (items.length === 0) {
        if (emptyState) emptyState.hidden = false;
        wishlistGrid.hidden = true;
        wishlistGrid.innerHTML = '';
        return;
      }

      Promise.all(items.map(function (item) {
        // Older wishlist entries saved before the cookie stored a product
        // handle (or a product later renamed/deleted) resolve to null here —
        // filtered out below instead of leaving a permanent blank gap.
        if (!item.handle) return Promise.resolve(null);
        return fetch('/products/' + item.handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var loaded = products.filter(Boolean);

        // Self-heal: drop any saved item that no longer resolves to a real
        // product (stale handle, deleted/renamed product) so it doesn't keep
        // reserving a permanently-blank slot on every future visit.
        if (loaded.length !== items.length) {
          var stillValidHandles = loaded.map(function (p) { return p.handle; });
          var cleaned = items.filter(function (it) { return stillValidHandles.indexOf(it.handle) !== -1; });
          if (window.__saveWishlist) window.__saveWishlist(cleaned);
        }

        if (emptyState) emptyState.hidden = loaded.length > 0;
        wishlistGrid.hidden = loaded.length === 0;
        wishlistGrid.innerHTML = '';

        loaded.forEach(function (product) {
          var article = document.createElement('article');
          article.className = 'product-card';
          article.innerHTML = buildCardHtml(product);
          wishlistGrid.appendChild(article);
        });
      });
    }

    window.__renderWishlistPage = renderWishlistPage;
    renderWishlistPage();
  })();

  // ===========================
  // ARTICLE PAGE — reading progress bar + auto-built table of contents
  // ===========================
  (function () {
    var article = document.querySelector('.article-main__content');
    if (!article) return;

    // Reading progress bar — fills as the visitor scrolls through the article body.
    var progressBar = document.querySelector('.article-progress__bar');
    if (progressBar) {
      var updateProgress = function () {
        var rect = article.getBoundingClientRect();
        var articleTop = rect.top + window.scrollY;
        var articleHeight = article.offsetHeight;
        var viewportH = window.innerHeight;
        var scrolled = window.scrollY - articleTop + viewportH * 0.4;
        var pct = Math.min(Math.max(scrolled / articleHeight, 0), 1) * 100;
        progressBar.style.width = pct + '%';
      };
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    // Table of contents — built from the article's own h2/h3 headings, so it
    // stays accurate for every post with no manual maintenance.
    var tocList = document.getElementById('article-toc-list');
    var tocWrap = document.querySelector('.article-toc');
    if (tocList && tocWrap) {
      var headings = article.querySelectorAll('h2, h3');
      if (headings.length < 2) {
        tocWrap.hidden = true;
      } else {
        tocWrap.hidden = false;
        headings.forEach(function (h, i) {
          if (!h.id) h.id = 'toc-' + i + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
          var li = document.createElement('li');
          li.className = 'article-toc__item' + (h.tagName === 'H3' ? ' article-toc__item--sub' : '');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.className = 'article-toc__link';
          a.textContent = h.textContent;
          li.appendChild(a);
          tocList.appendChild(li);
        });

        var tocLinks = tocList.querySelectorAll('.article-toc__link');
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
            var active = tocList.querySelector('a[href="#' + entry.target.id + '"]');
            if (active) active.classList.add('is-active');
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        headings.forEach(function (h) { observer.observe(h); });
      }
    }
  })();

});

// Festive Offer Popup — shows a promo-code popup after a configurable
// delay, respecting the "Show frequency" setting so repeat visitors
// aren't nagged every page load. Frequency state lives in localStorage
// (persists across tabs/sessions); "once_per_session" also checks
// sessionStorage so it still resets per new browser session.
document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('[data-festive-popup]');
  if (!popup) return;

  var STORAGE_KEY = 'cs-festive-popup-last-shown';
  var frequency = popup.dataset.frequency || 'once_per_session';
  var delaySeconds = parseFloat(popup.dataset.delay);
  if (isNaN(delaySeconds)) delaySeconds = 4;

  function shouldShow() {
    if (frequency === 'every_visit') return true;
    if (frequency === 'once_per_session') {
      try {
        if (sessionStorage.getItem(STORAGE_KEY)) return false;
      } catch (e) {}
      return true;
    }
    var days = frequency === 'once_per_week' ? 7 : 1;
    try {
      var last = localStorage.getItem(STORAGE_KEY);
      if (!last) return true;
      var elapsedMs = Date.now() - parseInt(last, 10);
      return elapsedMs > days * 24 * 60 * 60 * 1000;
    } catch (e) {
      return true;
    }
  }

  function markShown() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  var lastFocus = null;

  function openPopup() {
    lastFocus = document.activeElement;
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('festive-popup-open');
    var closeBtn = popup.querySelector('.festive-popup__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    markShown();
  }

  function closePopup() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('festive-popup-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  if (shouldShow()) {
    setTimeout(openPopup, delaySeconds * 1000);
  }

  popup.querySelectorAll('[data-festive-popup-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-visible')) closePopup();
  });

  // Side tab ("GET 10% OFF") — opens the popup on demand, regardless of the
  // automatic show frequency. Its ✕ hides it for the rest of the browser session.
  var tab = document.querySelector('[data-festive-tab]');
  var TAB_DISMISSED_KEY = 'cs-festive-tab-dismissed';
  if (tab) {
    var tabDismissed = false;
    try { tabDismissed = !!sessionStorage.getItem(TAB_DISMISSED_KEY); } catch (e) {}
    if (!tabDismissed) tab.hidden = false;
    tab.querySelector('[data-festive-tab-open]').addEventListener('click', openPopup);
    tab.querySelector('[data-festive-tab-close]').addEventListener('click', function () {
      tab.hidden = true;
      try { sessionStorage.setItem(TAB_DISMISSED_KEY, '1'); } catch (e) {}
    });
  }

  var codeEl = popup.querySelector('[data-festive-popup-code]');
  if (codeEl) popup.querySelectorAll('[data-festive-popup-copy]').forEach(function (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = codeEl.textContent.trim();
      var label = copyBtn.querySelector('[data-copy-label]');
      function showCopied() {
        copyBtn.classList.add('is-copied');
        if (label) label.textContent = 'Copied!';
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (label) label.textContent = 'Copy';
        }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function () {});
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try { document.execCommand('copy'); showCopied(); } catch (e) {}
        document.body.removeChild(textarea);
      }
    });
  });
});

// PDP Main Image Hover-Zoom — only the main product image, only on
// pointer devices that actually support hover (desktop/trackpad/mouse),
// so touch devices are untouched. The image scales up and its
// transform-origin follows the cursor position within the wrapper, which
// is clipped (overflow: hidden) so the zoomed image can never spill
// outside the existing gallery card.
document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.getElementById('pdp2-main-img-wrap');
  if (!wrap) return;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  wrap.classList.add('is-zoomable');

  wrap.addEventListener('mouseenter', function () {
    wrap.classList.add('is-zooming');
  });

  wrap.addEventListener('mousemove', function (e) {
    var img = document.getElementById('pdp2-main-img');
    if (!img) return;
    var rect = wrap.getBoundingClientRect();
    var xPct = ((e.clientX - rect.left) / rect.width) * 100;
    var yPct = ((e.clientY - rect.top) / rect.height) * 100;
    xPct = Math.max(0, Math.min(100, xPct));
    yPct = Math.max(0, Math.min(100, yPct));
    img.style.transformOrigin = xPct + '% ' + yPct + '%';
  });

  wrap.addEventListener('mouseleave', function () {
    wrap.classList.remove('is-zooming');
    var img = document.getElementById('pdp2-main-img');
    if (img) img.style.transformOrigin = '';
  });
});

// Testimonials — now a pure-CSS dual-row marquee (same technique as the
// About page's "brands we carry" section), so no JS is needed to drive it;
// it just animates continuously and pauses on hover via CSS.
